export const eventConstants = {
    REGISTER_REQUEST: 'EVENT_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'EVENT_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'EVENT_REGISTER_FAILURE',

    GETALL_REQUEST: 'EVENT_GETALL_REQUEST',
    GETALL_SUCCESS: 'EVENT_GETALL_SUCCESS',
    GETALL_FAILURE: 'EVENT_GETALL_FAILURE',

    DELETE_REQUEST: 'EVENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'EVENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'EVENT_DELETE_FAILURE',
    
    ADD_USER_REQUEST: 'POST_ADD_USER_REQUEST',
    ADD_USER_SUCCESS: 'POST_ADD_USER_SUCCESS',
    ADD_USER_FAILURE: 'POST_ADD_USER_FAILURE',
    ADD_USER_CLEAR_STATE: 'POST_USER_CLEAR_STATE',

    ADD_ADJUST_LOYALTY_REQUEST: 'ADD_ADJUST_LOYALTY_REQUEST',
    ADD_ADJUST_LOYALTY_SUCCESS: 'ADD_ADJUST_LOYALTY_SUCCESS',
    ADD_ADJUST_LOYALTY_FAILURE: 'ADD_ADJUST_LOYALTY_FAILURE',
    ADD_ADJUST_LOYALTY_CLEAR_STATE: "ADD_ADJUST_LOYALTY_CLEAR_STATE",

    UPDATE_ADJUST_LOYALTY_REQUEST: 'UPDATE_ADJUST_LOYALTY_REQUEST',
    UPDATE_ADJUST_LOYALTY_SUCCESS: 'UPDATE_ADJUST_LOYALTY_SUCCESS',
    UPDATE_ADJUST_LOYALTY_FAILURE: 'UPDATE_ADJUST_LOYALTY_FAILURE',
 

    UPLOAD_CUSTOMER_TIER_REQUEST: 'POST_UPLOAD_CUSTOMER_TIER_REQUEST',
    UPLOAD_CUSTOMER_TIER_SUCCESS: 'POST_UPLOAD_CUSTOMER_TIER_SUCCESS',
    UPLOAD_CUSTOMER_TIER_FAILURE: 'POST_UPLOAD_CUSTOMER_TIER_FAILURE',
    UPLOAD_CUSTOMER_TIER_CLEAR_TOAST: 'UPLOAD_CUSTOMER_TIER_CLEAR_TOAST',

    SOLD_TO_MANAGMENT_REQUEST: 'GET_SOLD_TO_MANAGMENT_REQUEST',
    SOLD_TO_MANAGMENT_SUCCESS: 'GET_SOLD_TO_MANAGMENT_SUCCESS',
    SOLD_TO_MANAGMENT_FAILURE: 'GET_SOLD_TO_MANAGMENT_FAILURE',
    SOLD_TO_MANAGMENT_CLEAR: 'SOLD_TO_MANAGMENT_CLEAR',

    PRODUCT_MASTER_REQUEST: 'GET_PRODUCT_MASTER_REQUEST',
    PRODUCT_MASTER_SUCCESS: 'GET_PRODUCT_MASTER_SUCCESS',
    PRODUCT_MASTER_FAILURE: 'GET_PRODUCT_MASTER_FAILURE',

    PRODUCT_GROUP_MASTER_LIST_REQUEST: 'GET_PRODUCT_GROUP_MASTER_LIST_REQUEST',
    PRODUCT_GROUP_MASTER_LIST_SUCCESS: 'GET_PRODUCT_GROUP_MASTER_LIST_SUCCESS',
    PRODUCT_GROUP_MASTER_LIST_FAILURE: 'GET_PRODUCT_GROUP_MASTER_LIST_FAILURE',
    PRODUCT_GROUP_MASTER_LIST_CLEAR_STATE: 'PRODUCT_GROUP_MASTER_LIST_CLEAR_STATE',

    ADD_PRODUCT_GROUP_REQUEST: 'ADD_ADD_PRODUCT_GROUP_REQUEST',
    ADD_PRODUCT_GROUP_SUCCESS: 'ADD_ADD_PRODUCT_GROUP_SUCCESS',
    ADD_PRODUCT_GROUP_FAILURE: 'ADD_ADD_PRODUCT_GROUP_FAILURE',
    ADD_PRODUCT_GROUP_CLEAR_TOAST: 'ADD_PRODUCT_GROUP_CLEAR_TOAST',

    PRODUCT_GROUP_SEARCH_REQUEST: 'GET_PRODUCT_GROUP_SEARCH_REQUEST',
    PRODUCT_GROUP_SEARCH_SUCCESS: 'GET_PRODUCT_GROUP_SEARCH_SUCCESS',
    PRODUCT_GROUP_SEARCH_FAILURE: 'GET_PRODUCT_GROUP_SEARCH_FAILURE',
    PRODUCT_GROUP_SEARCH_CLEAR: 'PRODUCT_GROUP_SEARCH_CLEAR',

    PRODUCT_MASTER_DETAIL_REQUEST: 'GET_PRODUCT_MASTER_DETAIL_REQUEST',
    PRODUCT_MASTER_DETAIL_SUCCESS: 'GET_PRODUCT_MASTER_DETAIL_SUCCESS',
    PRODUCT_MASTER_DETAIL_FAILURE: 'GET_PRODUCT_MASTER_DETAIL_FAILURE',

    GEOGRAPHY_MASTER_UPLOAD_REQUEST: 'POST_GEOGRAPHY_MASTER_UPLOAD_REQUEST',
    GEOGRAPHY_MASTER_UPLOAD_SUCCESS: 'POST_GEOGRAPHY_MASTER_UPLOAD_SUCCESS',
    GEOGRAPHY_MASTER_UPLOAD_FAILURE: 'POST_GEOGRAPHY_MASTER_UPLOAD_FAILURE',

    INSEE_DESC_UPDATE_REQUEST: 'PUT_INSEE_DESC_UPDATE_REQUEST',
    INSEE_DESC_UPDATE_SUCCESS: 'PUT_INSEE_DESC_UPDATE_SUCCESS',
    INSEE_DESC_UPDATE_FAILURE: 'PUT_INSEE_DESC_UPDATE_FAILURE',

    PRODUCT_MASTER_SEARCH_REQUEST: 'GET_PRODUCT_MASTER_SEARCH_REQUEST',
    PRODUCT_MASTER_SEARCH_SUCCESS: 'GET_PRODUCT_MASTER_SEARCH_SUCCESS',
    PRODUCT_MASTER_SEARCH_FAILURE: 'GET_PRODUCT_MASTER_SEARCH_FAILURE',

    CONTACT_TOGGLE_REQUEST: 'POST_CONTACT_TOGGLE_REQUEST',
    CONTACT_TOGGLE_SUCCESS: 'POST_CONTACT_TOGGLE_SUCCESS',
    CONTACT_TOGGLE_FAILURE: 'POST_CONTACT_TOGGLE_FAILURE',
    CONTACT_TOGGLE_CLEAR_TOAST: 'CONTACT_TOGGLE_CLEAR_TOAST',

    ACCOUNT_CONTACT_LIST_REQUEST: "GET_ACCOUNT_CONTACT_LIST_REQUEST",
    ACCOUNT_CONTACT_LIST_SUCCESS: "GET_ACCOUNT_CONTACT_LIST_SUCCESS",
    ACCOUNT_CONTACT_LIST_FAILURE: "GET_ACCOUNT_CONTACT_LIST_FAILURE",
    ACCOUNT_CONTACT_LIST_CLEAR: "ACCOUNT_CONTACT_LIST_CLEAR",

    PRODUCT_GROUP_DETAIL_LIST_REQUEST: "GET_PRODUCT_GROUP_DETAIL_LIST_REQUEST",
    PRODUCT_GROUP_DETAIL_LIST_SUCCESS: "GET_PRODUCT_GROUP_DETAIL_LIST_SUCCESS",
    PRODUCT_GROUP_DETAIL_LIST_FAILURE: "GET_PRODUCT_GROUP_DETAIL_LIST_FAILURE",

    PRODUCT_IMAGE_UPLOAD_REQUEST: 'POST_PRODUCT_IMAGE_UPLOAD_REQUEST',
    PRODUCT_IMAGE_UPLOAD_SUCCESS: 'POST_PRODUCT_IMAGE_UPLOAD_SUCCESS',
    PRODUCT_IMAGE_UPLOAD_FAILURE: 'POST_PRODUCT_IMAGE_UPLOAD_FAILURE',
    PRODUCT_IMAGE_UPLOAD_CLEAR_STATE: 'PRODUCT_IMAGE_UPLOAD_CLEAR_STATE',

    DIVISION_LIST_REQUEST: 'GET_DIVISION_LIST_REQUEST',
    DIVISION_LIST_SUCCESS: 'GET_DIVISION_LIST_SUCCESS',
    DIVISION_LIST_FAILURE: 'GET_DIVISION_LIST_FAILURE',

    ADD_DIVISION_REQUEST: 'POST_ADD_DIVISION_REQUEST',
    ADD_DIVISION_SUCCESS: 'POST_ADD_DIVISION_SUCCESS',
    ADD_DIVISION_FAILURE: 'POST_ADD_DIVISION_FAILURE',
    ADD_DIVISION_RESET: 'POST_ADD_DIVISION_RESET',

    UPDATE_DIVISION_REQUEST: 'PUT_UPDATE_DIVISION_REQUEST',
    UPDATE_DIVISION_SUCCESS: 'PUT_UPDATE_DIVISION_SUCCESS',
    UPDATE_DIVISION_FAILURE: 'PUT_UPDATE_DIVISION_FAILURE',
    UPDATE_DIVISION_RESET: 'PUT_UPDATE_DIVISION_RESET',

    DELETE_DIVISION_REQUEST: 'DELETE_DIVISION_REQUEST',
    DELETE_DIVISION_SUCCESS: 'DELETE_DIVISION_SUCCESS',
    DELETE_DIVISION_FAILURE: 'DELETE_DIVISION_FAILURE',
    DELETE_DIVISION_RESET: 'DELETE_DIVISION_RESET',

    BUSINESS_SEGMENT_LIST_REQUEST: 'GET_BUSINESS_SEGMENT_LIST_REQUEST',
    BUSINESS_SEGMENT_LIST_SUCCESS: 'GET_BUSINESS_SEGMENT_LIST_SUCCESS',
    BUSINESS_SEGMENT_LIST_FAILURE: 'GET_BUSINESS_SEGMENT_LIST_FAILURE',

    ADD_BUSINESS_SEGMENT_REQUEST: 'POST_ADD_BUSINESS_SEGMENT_REQUEST',
    ADD_BUSINESS_SEGMENT_SUCCESS: 'POST_ADD_BUSINESS_SEGMENT_SUCCESS',
    ADD_BUSINESS_SEGMENT_FAILURE: 'POST_ADD_BUSINESS_SEGMENT_FAILURE',

    DISTRIBUTION_CHANNEL_LIST_REQUEST: 'GET_DISTRIBUTION_CHANNEL_LIST_REQUEST',
    DISTRIBUTION_CHANNEL_LIST_SUCCESS: 'GET_DISTRIBUTION_CHANNEL_LIST_SUCCESS',
    DISTRIBUTION_CHANNEL_LIST_FAILURE: 'GET_DISTRIBUTION_CHANNEL_LIST_FAILURE',

    ADD_DISTRIBUTION_CHANNEL_REQUEST: 'POST_ADD_DISTRIBUTION_CHANNEL_REQUEST',
    ADD_DISTRIBUTION_CHANNEL_SUCCESS: 'POST_ADD_DISTRIBUTION_CHANNEL_SUCCESS',
    ADD_DISTRIBUTION_CHANNEL_FAILURE: 'POST_ADD_DISTRIBUTION_CHANNEL_FAILURE',
    ADD_DISTRIBUTION_CHANNEL_RESET: 'POST_ADD_DISTRIBUTION_CHANNEL_RESET',

    SHIPPING_CONDITION_REQUEST: 'GET_SHIPPING_CONDITION_REQUEST',
    SHIPPING_CONDITION_SUCCESS: 'GET_SHIPPING_CONDITION_SUCCESS',
    SHIPPING_CONDITION_FAILURE: 'GET_SHIPPING_CONDITION_FAILURE',

    ADD_SHIPPING_CONDITION_REQUEST: 'POST_ADD_SHIPPING_CONDITION_REQUEST',
    ADD_SHIPPING_CONDITION_SUCCESS: 'POST_ADD_SHIPPING_CONDITION_SUCCESS',
    ADD_SHIPPING_CONDITION_FAILURE: 'POST_ADD_SHIPPING_CONDITION_FAILURE',
    ADD_SHIPPING_CONDITION_RESET: 'POST_ADD_SHIPPING_CONDITION_RESET',

    SPECIAL_PROCESSING_REQUEST: 'GET_SPECIAL_PROCESSING_REQUEST',
    SPECIAL_PROCESSING_SUCCESS: 'GET_SPECIAL_PROCESSING_SUCCESS',
    SPECIAL_PROCESSING_FAILURE: 'GET_SPECIAL_PROCESSING_FAILURE',


    SUB_DEALER_LIST_REQUEST: 'GET_SUB_DEALER_LIST_REQUEST',
    SUB_DEALER_LIST_SUCCESS: 'GET_SUB_DEALER_LIST_SUCCESS',
    SUB_DEALER_LIST_FAILURE: 'GET_SUB_DEALER_LIST_FAILURE',

    ADD_SPECIAL_PROCESSING_REQUEST: 'POST_ADD_SPECIAL_PROCESSING_REQUEST',
    ADD_SPECIAL_PROCESSING_SUCCESS: 'POST_ADD_SPECIAL_PROCESSING_SUCCESS',
    ADD_SPECIAL_PROCESSING_FAILURE: 'POST_ADD_SPECIAL_PROCESSING_FAILURE',
    ADD_SPECIAL_PROCESSING_RESET: 'POST_ADD_SPECIAL_PROCESSING_RESET',

    TRANSPORTOR_ZONE_REQUEST: 'GET_TRANSPORTOR_ZONE_REQUEST',
    TRANSPORTOR_ZONE_SUCCESS: 'GET_TRANSPORTOR_ZONE_SUCCESS',
    TRANSPORTOR_ZONE_FAILURE: 'GET_TRANSPORTOR_ZONE_FAILURE',

    ADD_TRANSPORTOR_ZONE_REQUEST: 'POST_ADD_TRANSPORTOR_ZONE_REQUEST',
    ADD_TRANSPORTOR_ZONE_SUCCESS: 'POST_ADD_TRANSPORTOR_ZONE_SUCCESS',
    ADD_TRANSPORTOR_ZONE_FAILURE: 'POST_ADD_TRANSPORTOR_ZONE_FAILURE',
    ADD_TRANSPORTOR_ZONE_RESET: 'POST_ADD_TRANSPORTOR_ZONE_RESET',

    SHIPPING_TYPE_REQUEST: 'GET_SHIPPING_TYPE_REQUEST',
    SHIPPING_TYPE_SUCCESS: 'GET_SHIPPING_TYPE_SUCCESS',
    SHIPPING_TYPE_FAILURE: 'GET_SHIPPING_TYPE_FAILURE',

    ADD_SHIPPING_TYPE_REQUEST: 'POST_ADD_SHIPPING_TYPE_REQUEST',
    ADD_SHIPPING_TYPE_SUCCESS: 'POST_ADD_SHIPPING_TYPE_SUCCESS',
    ADD_SHIPPING_TYPE_FAILURE: 'POST_ADD_SHIPPING_TYPE_FAILURE',
    ADD_SHIPPING_TYPE_RESET: 'POST_ADD_SHIPPING_TYPE_RESET',

    CASE_STATUS_LIST_REQUEST: 'GET_CASE_STATUS_LIST_REQUEST',
    CASE_STATUS_LIST_SUCCESS: 'GET_CASE_STATUS_LIST_SUCCESS',
    CASE_STATUS_LIST_FAILURE: 'GET_CASE_STATUS_LIST_FAILURE',

    ADD_CASE_STATUS_REQUEST: 'POST_ADD_CASE_STATUS_REQUEST',
    ADD_CASE_STATUS_SUCCESS: 'POST_ADD_CASE_STATUS_SUCCESS',
    ADD_CASE_STATUS_FAILURE: 'POST_ADD_CASE_STATUS_FAILURE',
    ADD_CASE_STATUS_RESET: 'POST_ADD_CASE_STATUS_RESET',
    ADD_CASE_STATUS_CLEAR_TOAST: 'ADD_CASE_STATUS_CLEAR_TOAST',

    UPDATE_CASE_STATUS_REQUEST: 'PUT_UPDATE_CASE_STATUS_REQUEST',
    UPDATE_CASE_STATUS_SUCCESS: 'PUT_UPDATE_CASE_STATUS_SUCCESS',
    UPDATE_CASE_STATUS_FAILURE: 'PUT_UPDATE_CASE_STATUS_FAILURE',
    UPDATE_CASE_STATUS_RESET: 'PUT_UPDATE_CASE_STATUS_RESET',

    DELETE_CASE_STATUS_REQUEST: 'DELETE_CASE_STATUS_REQUEST',
    DELETE_CASE_STATUS_SUCCESS: 'DELETE_CASE_STATUS_SUCCESS',
    DELETE_CASE_STATUS_FAILURE: 'DELETE_CASE_STATUS_FAILURE',
    DELETE_CASE_STATUS_RESET: 'DELETE_CASE_STATUS_RESET',

    CHECKBOX_TOGGLE_REQUEST: 'GET_CHECKBOX_TOGGLE_REQUEST',
    CHECKBOX_TOGGLE_SUCCESS: 'GET_CHECKBOX_TOGGLE_SUCCESS',
    CHECKBOX_TOGGLE_FAILURE: 'GET_CHECKBOX_TOGGLE_FAILURE',

    CASE_TYPE_LIST_REQUEST: 'GET_CASE_TYPE_LIST_REQUEST',
    CASE_TYPE_LIST_SUCCESS: 'GET_CASE_TYPE_LIST_SUCCESS',
    CASE_TYPE_LIST_FAILURE: 'GET_CASE_TYPE_LIST_FAILURE',

    ADD_CASE_TYPE_REQUEST: 'POST_ADD_CASE_TYPE_REQUEST',
    ADD_CASE_TYPE_SUCCESS: 'POST_ADD_CASE_TYPE_SUCCESS',
    ADD_CASE_TYPE_FAILURE: 'POST_ADD_CASE_TYPE_FAILURE',
    ADD_CASE_TYPE_RESET: 'POST_ADD_CASE_TYPE_RESET',

    UPDATE_CASE_TYPE_REQUEST: 'PUT_UPDATE_CASE_TYPE_REQUEST',
    UPDATE_CASE_TYPE_SUCCESS: 'PUT_UPDATE_CASE_TYPE_SUCCESS',
    UPDATE_CASE_TYPE_FAILURE: 'PUT_UPDATE_CASE_TYPE_FAILURE',
    UPDATE_CASE_TYPE_RESET: 'PUT_UPDATE_CASE_TYPE_RESET',

    DELETE_CASE_TYPE_REQUEST: 'DELETE_CASE_TYPE_REQUEST',
    DELETE_CASE_TYPE_SUCCESS: 'DELETE_CASE_TYPE_SUCCESS',
    DELETE_CASE_TYPE_FAILURE: 'DELETE_CASE_TYPE_FAILURE',
    DELETE_CASE_TYPE_RESET: 'DELETE_CASE_TYPE_RESET',

    ASSIGN_PRODUCT_REQUEST: 'GET_ASSIGN_PRODUCT_REQUEST',
    ASSIGN_PRODUCT_SUCCESS: 'GET_ASSIGN_PRODUCT_SUCCESS',
    ASSIGN_PRODUCT_FAILURE: 'GET_ASSIGN_PRODUCT_FAILURE',

    CONTACT_STATUS_REQUEST: 'PUT_CONTACT_STATUS_REQUEST',
    CONTACT_STATUS_SUCCESS: 'PUT_CONTACT_STATUS_SUCCESS',
    CONTACT_STATUS_FAILURE: 'PUT_CONTACT_STATUS_FAILURE',

    PRODUCT_GROUP_STATUS_REQUEST: 'PUT_PRODUCT_GROUP_STATUS_REQUEST',
    PRODUCT_GROUP_STATUS_SUCCESS: 'PUT_PRODUCT_GROUP_STATUS_SUCCESS',
    PRODUCT_GROUP_STATUS_FAILURE: 'PUT_PRODUCT_GROUP_STATUS_FAILURE',

    ACTIVE_PRODUCT_REQUEST: 'GET_ACTIVE_PRODUCT_REQUEST',
    ACTIVE_PRODUCT_SUCCESS: 'GET_ACTIVE_PRODUCT_SUCCESS',
    ACTIVE_PRODUCT_FAILURE: 'GET_ACTIVE_PRODUCT_FAILURE',

    UPDATE_PRODUCT_GROUP_REQUEST: 'PUT_UPDATE_PRODUCT_GROUP_REQUEST',
    UPDATE_PRODUCT_GROUP_SUCCESS: 'PUT_UPDATE_PRODUCT_GROUP_SUCCESS',
    UPDATE_PRODUCT_GROUP_FAILURE: 'PUT_UPDATE_PRODUCT_GROUP_FAILURE',

    PRODUCT_SELECT_PRODUCT_REQUEST: 'GET_PRODUCT_SELECT_PRODUCT_REQUEST',
    PRODUCT_SELECT_PRODUCT_SUCCESS: 'GET_PRODUCT_SELECT_PRODUCT_SUCCESS',
    PRODUCT_SELECT_PRODUCT_FAILURE: 'GET_PRODUCT_SELECT_PRODUCT_FAILURE',

    PRODUCT_MASTER_ID_REQUEST: 'GET_PRODUCT_MASTER_ID_REQUEST',
    PRODUCT_MASTER_ID_SUCCESS: 'GET_PRODUCT_MASTER_ID_SUCCESS',
    PRODUCT_MASTER_ID_FAILURE: 'GET_PRODUCT_MASTER_ID_FAILURE',

    UNIT_MASTER_LIST_REQUEST: 'GET_UNIT_MASTER_LIST_REQUEST',
    UNIT_MASTER_LIST_SUCCESS: 'GET_UNIT_MASTER_LIST_SUCCESS',
    UNIT_MASTER_LIST_FAILURE: 'GET_UNIT_MASTER_LIST_FAILURE',

    ADD_UNIT_MASTER_REQUEST: 'POST_ADD_UNIT_MASTER_REQUEST',
    ADD_UNIT_MASTER_SUCCESS: 'POST_ADD_UNIT_MASTER_SUCCESS',
    ADD_UNIT_MASTER_FAILURE: 'POST_ADD_UNIT_MASTER_FAILURE',
    ADD_UNIT_MASTER_RESET: 'POST_ADD_UNIT_MASTER_RESET',

    ADD_PRICE_TYPE_REQUEST: 'POST_ADD_PRICE_TYPE_REQUEST',
    ADD_PRICE_TYPE_SUCCESS: 'POST_ADD_PRICE_TYPE_SUCCESS',
    ADD_PRICE_TYPE_FAILURE: 'POST_ADD_PRICE_TYPE_FAILURE',
    ADD_PRICE_TYPE_RESET: 'POST_ADD_PRICE_TYPE_RESET',

    PRICE_TYPE_LIST_REQUEST: 'GET_PRICE_TYPE_LIST_REQUEST',
    PRICE_TYPE_LIST_SUCCESS: 'GET_PRICE_TYPE_LIST_SUCCESS',
    PRICE_TYPE_LIST_FAILURE: 'GET_PRICE_TYPE_LIST_FAILURE',

    RETAILER_PAYMENT_MASTER_LIST_REQUEST: 'GET_RETAILER_PAYMENT_MASTER_LIST_REQUEST',
    RETAILER_PAYMENT_MASTER_LIST_SUCCESS: 'GET_RETAILER_PAYMENT_MASTER_LIST_SUCCESS',
    RETAILER_PAYMENT_MASTER_LIST_FAILURE: 'GET_RETAILER_PAYMENT_MASTER_LIST_FAILURE',

    ADD_RETAILER_PAYMENT_MASTER_REQUEST: 'POST_ADD_RETAILER_PAYMENT_MASTER_REQUEST',
    ADD_RETAILER_PAYMENT_MASTER_SUCCESS: 'POST_ADD_RETAILER_PAYMENT_MASTER_SUCCESS',
    ADD_RETAILER_PAYMENT_MASTER_FAILURE: 'POST_ADD_RETAILER_PAYMENT_MASTER_FAILURE',
    ADD_RETAILER_PAYMENT_MASTER_RESET: 'POST_ADD_RETAILER_PAYMENT_MASTER_RESET',

    PACKAGE_TYPE_MASTER_LIST_REQUEST: 'GET_PACKAGE_TYPE_MASTER_LIST_REQUEST',
    PACKAGE_TYPE_MASTER_LIST_SUCCESS: 'GET_PACKAGE_TYPE_MASTER_LIST_SUCCESS',
    PACKAGE_TYPE_MASTER_LIST_FAILURE: 'GET_PACKAGE_TYPE_MASTER_LIST_FAILURE',

    ADD_PACKAGE_TYPE_MASTER_REQUEST: 'POST_ADD_PACKAGE_TYPE_MASTER_REQUEST',
    ADD_PACKAGE_TYPE_MASTER_SUCCESS: 'POST_ADD_PACKAGE_TYPE_MASTER_SUCCESS',
    ADD_PACKAGE_TYPE_MASTER_FAILURE: 'POST_ADD_PACKAGE_TYPE_MASTER_FAILURE',
    ADD_PACKAGE_TYPE_MASTER_RESET: 'POST_ADD_PACKAGE_TYPE_MASTER_RESET',

    PROJECT_TYPE_MASTER_LIST_REQUEST: 'GET_PROJECT_TYPE_MASTER_LIST_REQUEST',
    PROJECT_TYPE_MASTER_LIST_SUCCESS: 'GET_PROJECT_TYPE_MASTER_LIST_SUCCESS',
    PROJECT_TYPE_MASTER_LIST_FAILURE: 'GET_PROJECT_TYPE_MASTER_LIST_FAILURE',

    ADD_PROJECT_TYPE_MASTER_REQUEST: 'POST_ADD_PROJECT_TYPE_MASTER_REQUEST',
    ADD_PROJECT_TYPE_MASTER_SUCCESS: 'POST_ADD_PROJECT_TYPE_MASTER_SUCCESS',
    ADD_PROJECT_TYPE_MASTER_FAILURE: 'POST_ADD_PROJECT_TYPE_MASTER_FAILURE',
    ADD_PROJECT_TYPE_MASTER_RESET: 'POST_ADD_PROJECT_TYPE_MASTER_RESET',


    MARKET_INTELLIGENCE_MASTER_LIST_REQUEST: 'GET_MARKET_INTELLIGENCE_MASTER_LIST_REQUEST',
    MARKET_INTELLIGENCE_MASTER_LIST_SUCCESS: 'GET_MARKET_INTELLIGENCE_MASTER_LIST_SUCCESS',
    MARKET_INTELLIGENCE_MASTER_LIST_FAILURE: 'GET_MARKET_INTELLIGENCE_MASTER_LIST_FAILURE',

    ADD_MARKET_INTELLIGENCE_MASTER_REQUEST: 'POST_ADD_MARKET_INTELLIGENCE_MASTER_REQUEST',
    ADD_MARKET_INTELLIGENCE_MASTER_SUCCESS: 'POST_ADD_MARKET_INTELLIGENCE_MASTER_SUCCESS',
    ADD_MARKET_INTELLIGENCE_MASTER_FAILURE: 'POST_ADD_MARKET_INTELLIGENCE_MASTER_FAILURE',
    ADD_MARKET_INTELLIGENCE_MASTER_RESET: 'POST_ADD_MARKET_INTELLIGENCE_MASTER_RESET',

    DELIVERY_MODE_MASTER_LIST_REQUEST: 'GET_DELIVERY_MODE_MASTER_LIST_REQUEST',
    DELIVERY_MODE_MASTER_LIST_SUCCESS: 'GET_DELIVERY_MODE_MASTER_LIST_SUCCESS',
    DELIVERY_MODE_MASTER_LIST_FAILURE: 'GET_DELIVERY_MODE_MASTER_LIST_FAILURE',

    ADD_DELIVERY_MODE_MASTER_REQUEST: 'POST_ADD_DELIVERY_MODE_MASTER_REQUEST',
    ADD_DELIVERY_MODE_MASTER_SUCCESS: 'POST_ADD_DELIVERY_MODE_MASTER_SUCCESS',
    ADD_DELIVERY_MODE_MASTER_FAILURE: 'POST_ADD_DELIVERY_MODE_MASTER_FAILURE',
    ADD_DELIVERY_MODE_MASTER_RESET: 'POST_ADD_DELIVERY_MODE_MASTER_RESET',

    SALES_DISTRICT_MASTER_LIST_REQUEST: 'GET_SALES_DISTRICT_MASTER_LIST_REQUEST',
    SALES_DISTRICT_MASTER_LIST_SUCCESS: 'GET_SALES_DISTRICT_MASTER_LIST_SUCCESS',
    SALES_DISTRICT_MASTER_LIST_FAILURE: 'GET_SALES_DISTRICT_MASTER_LIST_FAILURE',

    ADD_SALES_DISTRICT_MASTER_REQUEST: 'POST_ADD_SALES_DISTRICT_MASTER_REQUEST',
    ADD_SALES_DISTRICT_MASTER_SUCCESS: 'POST_ADD_SALES_DISTRICT_MASTER_SUCCESS',
    ADD_SALES_DISTRICT_MASTER_FAILURE: 'POST_ADD_SALES_DISTRICT_MASTER_FAILURE',
    ADD_SALES_DISTRICT_MASTER_RESET: 'POST_ADD_SALES_DISTRICT_MASTER_RESET',

    PREFERRED_TRUCK_TYPES_MASTER_LIST_REQUEST: 'GET_PREFERRED_TRUCK_TYPES_MASTER_LIST_REQUEST',
    PREFERRED_TRUCK_TYPES_MASTER_LIST_SUCCESS: 'GET_PREFERRED_TRUCK_TYPES_MASTER_LIST_SUCCESS',
    PREFERRED_TRUCK_TYPES_MASTER_LIST_FAILURE: 'GET_PREFERRED_TRUCK_TYPES_MASTER_LIST_FAILURE',

    ADD_PREFERRED_TRUCK_TYPES_MASTER_REQUEST: 'POST_ADD_PREFERRED_TRUCK_TYPES_MASTER_REQUEST',
    ADD_PREFERRED_TRUCK_TYPES_MASTER_SUCCESS: 'POST_ADD_PREFERRED_TRUCK_TYPES_MASTER_SUCCESS',
    ADD_PREFERRED_TRUCK_TYPES_MASTER_FAILURE: 'POST_ADD_PREFERRED_TRUCK_TYPES_MASTER_FAILURE',
    ADD_PREFERRED_TRUCK_TYPES_MASTER_RESET: 'POST_ADD_PREFERRED_TRUCK_TYPES_MASTER_RESET',

    SALES_ORGANIZATION_MASTER_LIST_REQUEST: 'GET_SALES_ORGANIZATION_MASTER_LIST_REQUEST',
    SALES_ORGANIZATION_MASTER_LIST_SUCCESS: 'GET_SALES_ORGANIZATION_MASTER_LIST_SUCCESS',
    SALES_ORGANIZATION_MASTER_LIST_FAILURE: 'GET_SALES_ORGANIZATION_MASTER_LIST_FAILURE',

    ADD_SALES_ORGANIZATION_MASTER_REQUEST: 'POST_ADD_SALES_ORGANIZATION_MASTER_REQUEST',
    ADD_SALES_ORGANIZATION_MASTER_SUCCESS: 'POST_ADD_SALES_ORGANIZATION_MASTER_SUCCESS',
    ADD_SALES_ORGANIZATION_MASTER_FAILURE: 'POST_ADD_SALES_ORGANIZATION_MASTER_FAILURE',
    ADD_SALES_ORGANIZATION_MASTER_RESET: 'POST_ADD_SALES_ORGANIZATION_MASTER_RESET',

    SPECIAL_PROJECT_MASTER_LIST_REQUEST: 'GET_SPECIAL_PROJECT_MASTER_LIST_REQUEST',
    SPECIAL_PROJECT_MASTER_LIST_SUCCESS: 'GET_SPECIAL_PROJECT_MASTER_LIST_SUCCESS',
    SPECIAL_PROJECT_MASTER_LIST_FAILURE: 'GET_SPECIAL_PROJECT_MASTER_LIST_FAILURE',

    ADD_SPECIAL_PROJECT_MASTER_REQUEST: 'POST_ADD_SPECIAL_PROJECT_MASTER_REQUEST',
    ADD_SPECIAL_PROJECT_MASTER_SUCCESS: 'POST_ADD_SPECIAL_PROJECT_MASTER_SUCCESS',
    ADD_SPECIAL_PROJECT_MASTER_FAILURE: 'POST_ADD_SPECIAL_PROJECT_MASTER_FAILURE',
    ADD_SPECIAL_PROJECT_MASTER_RESET: 'POST_ADD_SPECIAL_PROJECT_MASTER_RESET',

    AREA_TYPE_MASTER_LIST_REQUEST: 'GET_AREA_TYPE_MASTER_LIST_REQUEST',
    AREA_TYPE_MASTER_LIST_SUCCESS: 'GET_AREA_TYPE_MASTER_LIST_SUCCESS',
    AREA_TYPE_MASTER_LIST_FAILURE: 'GET_AREA_TYPE_MASTER_LIST_FAILURE',

    ADD_AREA_TYPE_MASTER_REQUEST: 'POST_ADD_AREA_TYPE_MASTER_REQUEST',
    ADD_AREA_TYPE_MASTER_SUCCESS: 'POST_ADD_AREA_TYPE_MASTER_SUCCESS',
    ADD_AREA_TYPE_MASTER_FAILURE: 'POST_ADD_AREA_TYPE_MASTER_FAILURE',
    ADD_AREA_TYPE_MASTER_RESET: 'POST_ADD_AREA_TYPE_MASTER_RESET',

    STRATEGY_TYPE_MASTER_LIST_REQUEST: 'GET_STRATEGY_TYPE_MASTER_LIST_REQUEST',
    STRATEGY_TYPE_MASTER_LIST_SUCCESS: 'GET_STRATEGY_TYPE_MASTER_LIST_SUCCESS',
    STRATEGY_TYPE_MASTER_LIST_FAILURE: 'GET_STRATEGY_TYPE_MASTER_LIST_FAILURE',

    ADD_STRATEGY_TYPE_MASTER_REQUEST: 'POST_ADD_STRATEGY_TYPE_MASTER_REQUEST',
    ADD_STRATEGY_TYPE_MASTER_SUCCESS: 'POST_ADD_STRATEGY_TYPE_MASTER_SUCCESS',
    ADD_STRATEGY_TYPE_MASTER_FAILURE: 'POST_ADD_STRATEGY_TYPE_MASTER_FAILURE',
    ADD_STRATEGY_TYPE_MASTER_RESET: 'POST_ADD_STRATEGY_TYPE_MASTER_RESET',

    COMPATITOR_PRODUCT_MASTER_LIST_REQUEST: 'GET_COMPATITOR_PRODUCT_MASTER_LIST_REQUEST',
    COMPATITOR_PRODUCT_MASTER_LIST_SUCCESS: 'GET_COMPATITOR_PRODUCT_MASTER_LIST_SUCCESS',
    COMPATITOR_PRODUCT_MASTER_LIST_FAILURE: 'GET_COMPATITOR_PRODUCT_MASTER_LIST_FAILURE',

    ADD_COMPATITOR_PRODUCT_MASTER_REQUEST: 'POST_ADD_COMPATITOR_PRODUCT_MASTER_REQUEST',
    ADD_COMPATITOR_PRODUCT_MASTER_SUCCESS: 'POST_ADD_COMPATITOR_PRODUCT_MASTER_SUCCESS',
    ADD_COMPATITOR_PRODUCT_MASTER_FAILURE: 'POST_ADD_COMPATITOR_PRODUCT_MASTER_FAILURE',
    ADD_COMPATITOR_PRODUCT_MASTER_RESET: 'POST_ADD_COMPATITOR_PRODUCT_MASTER_RESET',

    ORDER_TYPE_MASTER_LIST_REQUEST: 'GET_ORDER_TYPE_MASTER_LIST_REQUEST',
    ORDER_TYPE_MASTER_LIST_SUCCESS: 'GET_ORDER_TYPE_MASTER_LIST_SUCCESS',
    ORDER_TYPE_MASTER_LIST_FAILURE: 'GET_ORDER_TYPE_MASTER_LIST_FAILURE',

    ADD_ORDER_TYPE_MASTER_REQUEST: 'POST_ADD_ORDER_TYPE_MASTER_REQUEST',
    ADD_ORDER_TYPE_MASTER_SUCCESS: 'POST_ADD_ORDER_TYPE_MASTER_SUCCESS',
    ADD_ORDER_TYPE_MASTER_FAILURE: 'POST_ADD_ORDER_TYPE_MASTER_FAILURE',

    PRODUCT_TYPE_MASTER_LIST_REQUEST: 'GET_PRODUCT_TYPE_MASTER_LIST_REQUEST',
    PRODUCT_TYPE_MASTER_LIST_SUCCESS: 'GET_PRODUCT_TYPE_MASTER_LIST_SUCCESS',
    PRODUCT_TYPE_MASTER_LIST_FAILURE: 'GET_PRODUCT_TYPE_MASTER_LIST_FAILURE',

    ADD_PRODUCT_TYPE_MASTER_REQUEST: 'POST_ADD_PRODUCT_TYPE_MASTER_REQUEST',
    ADD_PRODUCT_TYPE_MASTER_SUCCESS: 'POST_ADD_PRODUCT_TYPE_MASTER_SUCCESS',
    ADD_PRODUCT_TYPE_MASTER_FAILURE: 'POST_ADD_PRODUCT_TYPE_MASTER_FAILURE',
    ADD_PRODUCT_TYPE_MASTER_RESET: 'POST_ADD_PRODUCT_TYPE_MASTER_RESET',

    TRANSPORTER_MASTER_LIST_REQUEST: 'GET_TRANSPORTER_MASTER_LIST_REQUEST',
    TRANSPORTER_MASTER_LIST_SUCCESS: 'GET_TRANSPORTER_MASTER_LIST_SUCCESS',
    TRANSPORTER_MASTER_LIST_FAILURE: 'GET_TRANSPORTER_MASTER_LIST_FAILURE',

    ADD_TRANSPORTER_MASTER_REQUEST: 'POST_ADD_TRANSPORTER_MASTER_REQUEST',
    ADD_TRANSPORTER_MASTER_SUCCESS: 'POST_ADD_TRANSPORTER_MASTER_SUCCESS',
    ADD_TRANSPORTER_MASTER_FAILURE: 'POST_ADD_TRANSPORTER_MASTER_FAILURE',
    ADD_TRANSPORTER_MASTER_RESET: 'POST_ADD_TRANSPORTER_MASTER_RESET',

    CASE_ORIGIN_MASTER_LIST_REQUEST: 'GET_CASE_ORIGIN_MASTER_LIST_REQUEST',
    CASE_ORIGIN_MASTER_LIST_SUCCESS: 'GET_CASE_ORIGIN_MASTER_LIST_SUCCESS',
    CASE_ORIGIN_MASTER_LIST_FAILURE: 'GET_CASE_ORIGIN_MASTER_LIST_FAILURE',

    ADD_CASE_ORIGIN_MASTER_REQUEST: 'POST_ADD_CASE_ORIGIN_MASTER_REQUEST',
    ADD_CASE_ORIGIN_MASTER_SUCCESS: 'POST_ADD_CASE_ORIGIN_MASTER_SUCCESS',
    ADD_CASE_ORIGIN_MASTER_FAILURE: 'POST_ADD_CASE_ORIGIN_MASTER_FAILURE',
    ADD_CASE_ORIGIN_MASTER_RESET: 'POST_ADD_CASE_ORIGIN_MASTER_RESET',

    CATEGORY_MASTER_LIST_REQUEST: 'GET_CATEGORY_MASTER_LIST_REQUEST',
    CATEGORY_MASTER_LIST_SUCCESS: 'GET_CATEGORY_MASTER_LIST_SUCCESS',
    CATEGORY_MASTER_LIST_FAILURE: 'GET_CATEGORY_MASTER_LIST_FAILURE',

    ADD_CATEGORY_MASTER_REQUEST: 'POST_ADD_CATEGORY_MASTER_REQUEST',
    ADD_CATEGORY_MASTER_SUCCESS: 'POST_ADD_CATEGORY_MASTER_SUCCESS',
    ADD_CATEGORY_MASTER_FAILURE: 'POST_ADD_CATEGORY_MASTER_FAILURE',
    ADD_CATEGORY_MASTER_RESET: 'POST_ADD_CATEGORY_MASTER_RESET',
    ADD_CATEGORY_MASTER_CLEAR_TOAST: 'ADD_CATEGORY_MASTER_CLEAR_TOAST',

    UPDATE_CATEGORY_REQUEST: 'PUT_UPDATE_CATEGORY_REQUEST',
    UPDATE_CATEGORY_SUCCESS: 'PUT_UPDATE_CATEGORY_SUCCESS',
    UPDATE_CATEGORY_FAILURE: 'PUT_UPDATE_CATEGORY_FAILURE',
    UPDATE_CATEGORY_RESET: 'UPDATE_CATEGORY_RESET',

    DELETE_CATEGORY_MASTER_REQUEST: 'DELETE_CATEGORY_MASTER_REQUEST',
    DELETE_CATEGORY_MASTER_SUCCESS: 'DELETE_CATEGORY_MASTER_SUCCESS',
    DELETE_CATEGORY_MASTER_FAILURE: 'DELETE_CATEGORY_MASTER_FAILURE',
    DELETE_CATEGORY_MASTER_RESET: 'DELETE_CATEGORY_MASTER_RESET',


    CONSTRUCTION_PHASE_MASTER_LIST_REQUEST: 'GET_CONSTRUCTION_PHASE_MASTER_LIST_REQUEST',
    CONSTRUCTION_PHASE_MASTER_LIST_SUCCESS: 'GET_CONSTRUCTION_PHASE_MASTER_LIST_SUCCESS',
    CONSTRUCTION_PHASE_MASTER_LIST_FAILURE: 'GET_CONSTRUCTION_PHASE_MASTER_LIST_FAILURE',

    ADD_CONSTRUCTION_PHASE_MASTER_REQUEST: 'POST_ADD_CONSTRUCTION_PHASE_MASTER_REQUEST',
    ADD_CONSTRUCTION_PHASE_MASTER_SUCCESS: 'POST_ADD_CONSTRUCTION_PHASE_MASTER_SUCCESS',
    ADD_CONSTRUCTION_PHASE_MASTER_FAILURE: 'POST_ADD_CONSTRUCTION_PHASE_MASTER_FAILURE',
    ADD_CONSTRUCTION_PHASE_MASTER_RESET: 'POST_ADD_CONSTRUCTION_PHASE_MASTER_RESET',

    USER_ROLE_MASTER_LIST_REQUEST: 'GET_USER_ROLE_MASTER_LIST_REQUEST',
    USER_ROLE_MASTER_LIST_SUCCESS: 'GET_USER_ROLE_MASTER_LIST_SUCCESS',
    USER_ROLE_MASTER_LIST_FAILURE: 'GET_USER_ROLE_MASTER_LIST_FAILURE',

    ADD_USER_ROLE_MASTER_REQUEST: 'POST_ADD_USER_ROLE_MASTER_REQUEST',
    ADD_USER_ROLE_MASTER_SUCCESS: 'POST_ADD_USER_ROLE_MASTER_SUCCESS',
    ADD_USER_ROLE_MASTER_FAILURE: 'POST_ADD_USER_ROLE_MASTER_FAILURE',
    ADD_USER_ROLE_MASTER_RESET: 'POST_ADD_USER_ROLE_MASTER_RESET',

    TRUCK_TYPE_MASTER_LIST_REQUEST: 'GET_TRUCK_TYPE_MASTER_LIST_REQUEST',
    TRUCK_TYPE_MASTER_LIST_SUCCESS: 'GET_TRUCK_TYPE_MASTER_LIST_SUCCESS',
    TRUCK_TYPE_MASTER_LIST_FAILURE: 'GET_TRUCK_TYPE_MASTER_LIST_FAILURE',

    ADD_TRUCK_TYPE_MASTER_REQUEST: 'POST_ADD_TRUCK_TYPE_MASTER_REQUEST',
    ADD_TRUCK_TYPE_MASTER_SUCCESS: 'POST_ADD_TRUCK_TYPE_MASTER_SUCCESS',
    ADD_TRUCK_TYPE_MASTER_FAILURE: 'POST_ADD_TRUCK_TYPE_MASTER_FAILURE',
    ADD_TRUCK_TYPE_MASTER_RESET: 'POST_ADD_TRUCK_TYPE_MASTER_RESET',

    PROMOTION_TYPE_MASTER_LIST_REQUEST: 'GET_PROMOTION_TYPE_MASTER_LIST_REQUEST',
    PROMOTION_TYPE_MASTER_LIST_SUCCESS: 'GET_PROMOTION_TYPE_MASTER_LIST_SUCCESS',
    PROMOTION_TYPE_MASTER_LIST_FAILURE: 'GET_PROMOTION_TYPE_MASTER_LIST_FAILURE',

    ADD_PROMOTION_TYPE_MASTER_REQUEST: 'POST_ADD_PROMOTION_TYPE_MASTER_REQUEST',
    ADD_PROMOTION_TYPE_MASTER_SUCCESS: 'POST_ADD_PROMOTION_TYPE_MASTER_SUCCESS',
    ADD_PROMOTION_TYPE_MASTER_FAILURE: 'POST_ADD_PROMOTION_TYPE_MASTER_FAILURE',
    ADD_PROMOTION_TYPE_MASTER_RESET: 'POST_ADD_PROMOTION_TYPE_MASTER_RESET',

    PRICE_BOOK_MASTER_LIST_REQUEST: 'GET_PRICE_BOOK_MASTER_LIST_REQUEST',
    PRICE_BOOK_MASTER_LIST_SUCCESS: 'GET_PRICE_BOOK_MASTER_LIST_SUCCESS',
    PRICE_BOOK_MASTER_LIST_FAILURE: 'GET_PRICE_BOOK_MASTER_LIST_FAILURE',

    ADD_PRICE_BOOK_MASTER_REQUEST: 'POST_ADD_PRICE_BOOK_MASTER_REQUEST',
    ADD_PRICE_BOOK_MASTER_SUCCESS: 'POST_ADD_PRICE_BOOK_MASTER_SUCCESS',
    ADD_PRICE_BOOK_MASTER_FAILURE: 'POST_ADD_PRICE_BOOK_MASTER_FAILURE',
    ADD_PRICE_BOOK_MASTER_RESET: 'POST_ADD_PRICE_BOOK_MASTER_RESET',

    PRODUCT_PRODUCE_MASTER_LIST_REQUEST: 'GET_PRODUCT_PRODUCE_MASTER_LIST_REQUEST',
    PRODUCT_PRODUCE_MASTER_LIST_SUCCESS: 'GET_PRODUCT_PRODUCE_MASTER_LIST_SUCCESS',
    PRODUCT_PRODUCE_MASTER_LIST_FAILURE: 'GET_PRODUCT_PRODUCE_MASTER_LIST_FAILURE',

    ADD_PRODUCT_PRODUCE_MASTER_REQUEST: 'POST_ADD_PRODUCT_PRODUCE_MASTER_REQUEST',
    ADD_PRODUCT_PRODUCE_MASTER_SUCCESS: 'POST_ADD_PRODUCT_PRODUCE_MASTER_SUCCESS',
    ADD_PRODUCT_PRODUCE_MASTER_FAILURE: 'POST_ADD_PRODUCT_PRODUCE_MASTER_FAILURE',
    ADD_PRODUCT_PRODUCE_MASTER_RESET: 'POST_ADD_PRODUCT_PRODUCE_MASTER_RESET',

    DISTRIBUTION_AREA_MASTER_LIST_REQUEST: 'GET_DISTRIBUTION_AREA_MASTER_LIST_REQUEST',
    DISTRIBUTION_AREA_MASTER_LIST_SUCCESS: 'GET_DISTRIBUTION_AREA_MASTER_LIST_SUCCESS',
    DISTRIBUTION_AREA_MASTER_LIST_FAILURE: 'GET_DISTRIBUTION_AREA_MASTER_LIST_FAILURE',

    ADD_DISTRIBUTION_AREA_MASTER_REQUEST: 'POST_ADD_DISTRIBUTION_AREA_MASTER_REQUEST',
    ADD_DISTRIBUTION_AREA_MASTER_SUCCESS: 'POST_ADD_DISTRIBUTION_AREA_MASTER_SUCCESS',
    ADD_DISTRIBUTION_AREA_MASTER_FAILURE: 'POST_ADD_DISTRIBUTION_AREA_MASTER_FAILURE',
    ADD_DISTRIBUTION_AREA_MASTER_RESET: 'POST_ADD_DISTRIBUTION_AREA_MASTER_RESET',

    SUB_CATEGORY_MASTER_LIST_REQUEST: 'GET_SUB_CATEGORY_MASTER_LIST_REQUEST',
    SUB_CATEGORY_MASTER_LIST_SUCCESS: 'GET_SUB_CATEGORY_MASTER_LIST_SUCCESS',
    SUB_CATEGORY_MASTER_LIST_FAILURE: 'GET_SUB_CATEGORY_MASTER_LIST_FAILURE',

    ADD_SUB_CATEGORY_MASTER_REQUEST: 'POST_ADD_SUB_CATEGORY_MASTER_REQUEST',
    ADD_SUB_CATEGORY_MASTER_SUCCESS: 'POST_ADD_SUB_CATEGORY_MASTER_SUCCESS',
    ADD_SUB_CATEGORY_MASTER_FAILURE: 'POST_ADD_SUB_CATEGORY_MASTER_FAILURE',
    ADD_SUB_CATEGORY_MASTER_RESET: 'POST_ADD_SUB_CATEGORY_MASTER_RESET',

    UPDATE_SUB_CATEGORY_REQUEST: 'PUT_UPDATE_SUB_CATEGORY_REQUEST',
    UPDATE_SUB_CATEGORY_SUCCESS: 'PUT_UPDATE_SUB_CATEGORY_SUCCESS',
    UPDATE_SUB_CATEGORY_FAILURE: 'PUT_UPDATE_SUB_CATEGORY_FAILURE',
    UPDATE_SUB_CATEGORY_RESET: 'PUT_UPDATE_SUB_CATEGORY_RESET',

    DELETE_SUB_CATEGORY_REQUEST: 'DELETE_SUB_CATEGORY_REQUEST',
    DELETE_SUB_CATEGORY_SUCCESS: 'DELETE_SUB_CATEGORY_SUCCESS',
    DELETE_SUB_CATEGORY_FAILURE: 'DELETE_SUB_CATEGORY_FAILURE',
    DELETE_SUB_CATEGORY_RESET: 'DELETE_SUB_CATEGORY_RESET',


    DESCRIPTION_MASTER_LIST_REQUEST: 'GET_DESCRIPTION_MASTER_LIST_REQUEST',
    DESCRIPTION_MASTER_LIST_SUCCESS: 'GET_DESCRIPTION_MASTER_LIST_SUCCESS',
    DESCRIPTION_MASTER_LIST_FAILURE: 'GET_DESCRIPTION_MASTER_LIST_FAILURE',

    ADD_DESCRIPTION_MASTER_REQUEST: 'POST_ADD_DESCRIPTION_MASTER_REQUEST',
    ADD_DESCRIPTION_MASTER_SUCCESS: 'POST_ADD_DESCRIPTION_MASTER_SUCCESS',
    ADD_DESCRIPTION_MASTER_FAILURE: 'POST_ADD_DESCRIPTION_MASTER_FAILURE',
    ADD_DESCRIPTION_MASTER_RESET: 'POST_ADD_DESCRIPTION_MASTER_RESET',

    UPDATE_DESCRIPTION_REQUEST: 'PUT_UPDATE_DESCRIPTION_REQUEST',
    UPDATE_DESCRIPTION_SUCCESS: 'PUT_UPDATE_DESCRIPTION_SUCCESS',
    UPDATE_DESCRIPTION_FAILURE: 'PUT_UPDATE_DESCRIPTION_FAILURE',
    UPDATE_DESCRIPTION_RESET: 'PUT_UPDATE_DESCRIPTION_RESET',

    DELETE_DESCRIPTION_REQUEST: 'DELETE_DESCRIPTION_REQUEST',
    DELETE_DESCRIPTION_SUCCESS: 'DELETE_DESCRIPTION_SUCCESS',
    DELETE_DESCRIPTION_FAILURE: 'DELETE_DESCRIPTION_FAILURE',
    DELETE_DESCRIPTION_RESET: 'DELETE_DESCRIPTION_RESET',

    DELIVERY_STATUS_MASTER_LIST_REQUEST: 'GET_DELIVERY_STATUS_MASTER_LIST_REQUEST',
    DELIVERY_STATUS_MASTER_LIST_SUCCESS: 'GET_DELIVERY_STATUS_MASTER_LIST_SUCCESS',
    DELIVERY_STATUS_MASTER_LIST_FAILURE: 'GET_DELIVERY_STATUS_MASTER_LIST_FAILURE',

    ADD_DELIVERY_STATUS_MASTER_REQUEST: 'POST_ADD_DELIVERY_STATUS_MASTER_REQUEST',
    ADD_DELIVERY_STATUS_MASTER_SUCCESS: 'POST_ADD_DELIVERY_STATUS_MASTER_SUCCESS',
    ADD_DELIVERY_STATUS_MASTER_FAILURE: 'POST_ADD_DELIVERY_STATUS_MASTER_FAILURE',

    ACTION_STATUS_MASTER_LIST_REQUEST: 'GET_ACTION_STATUS_MASTER_LIST_REQUEST',
    ACTION_STATUS_MASTER_LIST_SUCCESS: 'GET_ACTION_STATUS_MASTER_LIST_SUCCESS',
    ACTION_STATUS_MASTER_LIST_FAILURE: 'GET_ACTION_STATUS_MASTER_LIST_FAILURE',

    ADD_ACTION_STATUS_MASTER_REQUEST: 'POST_ADD_ACTION_STATUS_MASTER_REQUEST',
    ADD_ACTION_STATUS_MASTER_SUCCESS: 'POST_ADD_ACTION_STATUS_MASTER_SUCCESS',
    ADD_ACTION_STATUS_MASTER_FAILURE: 'POST_ADD_ACTION_STATUS_MASTER_FAILURE',
    ADD_ACTION_STATUS_MASTER_RESET: 'POST_ADD_ACTION_STATUS_MASTER_RESET',

    ACTION_CATEGORY_MASTER_LIST_REQUEST: 'GET_ACTION_CATEGORY_MASTER_LIST_REQUEST',
    ACTION_CATEGORY_MASTER_LIST_SUCCESS: 'GET_ACTION_CATEGORY_MASTER_LIST_SUCCESS',
    ACTION_CATEGORY_MASTER_LIST_FAILURE: 'GET_ACTION_CATEGORY_MASTER_LIST_FAILURE',

    ADD_ACTION_CATEGORY_MASTER_REQUEST: 'POST_ADD_ACTION_CATEGORY_MASTER_REQUEST',
    ADD_ACTION_CATEGORY_MASTER_SUCCESS: 'POST_ADD_ACTION_CATEGORY_MASTER_SUCCESS',
    ADD_ACTION_CATEGORY_MASTER_FAILURE: 'POST_ADD_ACTION_CATEGORY_MASTER_FAILURE',
    ADD_ACTION_CATEGORY_MASTER_RESET: 'POST_ADD_ACTION_CATEGORY_MASTER_RESET',


    DEPARTMENT_MASTER_LIST_REQUEST: 'GET_DEPARTMENT_MASTER_LIST_REQUEST',
    DEPARTMENT_MASTER_LIST_SUCCESS: 'GET_DEPARTMENT_MASTER_LIST_SUCCESS',
    DEPARTMENT_MASTER_LIST_FAILURE: 'GET_DEPARTMENT_MASTER_LIST_FAILURE',

    ADD_DEPARTMENT_MASTER_REQUEST: 'POST_ADD_DEPARTMENT_MASTER_REQUEST',
    ADD_DEPARTMENT_MASTER_SUCCESS: 'POST_ADD_DEPARTMENT_MASTER_SUCCESS',
    ADD_DEPARTMENT_MASTER_FAILURE: 'POST_ADD_DEPARTMENT_MASTER_FAILURE',
    ADD_DEPARTMENT_MASTER_RESET: 'POST_ADD_DEPARTMENT_MASTER_RESET',

    FUNCTIONAL_ROLE_MASTER_LIST_REQUEST: 'GET_FUNCTIONAL_ROLE_MASTER_LIST_REQUEST',
    FUNCTIONAL_ROLE_MASTER_LIST_SUCCESS: 'GET_FUNCTIONAL_ROLE_MASTER_LIST_SUCCESS',
    FUNCTIONAL_ROLE_MASTER_LIST_FAILURE: 'GET_FUNCTIONAL_ROLE_MASTER_LIST_FAILURE',

    ADD_FUNCTIONAL_ROLE_MASTER_REQUEST: 'POST_ADD_FUNCTIONAL_ROLE_MASTER_REQUEST',
    ADD_FUNCTIONAL_ROLE_MASTER_SUCCESS: 'POST_ADD_FUNCTIONAL_ROLE_MASTER_SUCCESS',
    ADD_FUNCTIONAL_ROLE_MASTER_FAILURE: 'POST_ADD_FUNCTIONAL_ROLE_MASTER_FAILURE',
    ADD_FUNCTIONAL_ROLE_MASTER_RESET: 'POST_ADD_FUNCTIONAL_ROLE_MASTER_RESET',

    LEAD_SOURCE_MASTER_LIST_REQUEST: 'GET_LEAD_SOURCE_MASTER_LIST_REQUEST',
    LEAD_SOURCE_MASTER_LIST_SUCCESS: 'GET_LEAD_SOURCE_MASTER_LIST_SUCCESS',
    LEAD_SOURCE_MASTER_LIST_FAILURE: 'GET_LEAD_SOURCE_MASTER_LIST_FAILURE',

    ADD_LEAD_SOURCE_MASTER_REQUEST: 'POST_ADD_LEAD_SOURCE_MASTER_REQUEST',
    ADD_LEAD_SOURCE_MASTER_SUCCESS: 'POST_ADD_LEAD_SOURCE_MASTER_SUCCESS',
    ADD_LEAD_SOURCE_MASTER_FAILURE: 'POST_ADD_LEAD_SOURCE_MASTER_FAILURE',
    ADD_LEAD_SOURCE_MASTER_RESET: 'POST_ADD_LEAD_SOURCE_MASTER_RESET',


    LEAD_STAGE_MASTER_LIST_REQUEST: 'GET_LEAD_STAGE_MASTER_LIST_REQUEST',
    LEAD_STAGE_MASTER_LIST_SUCCESS: 'GET_LEAD_STAGE_MASTER_LIST_SUCCESS',
    LEAD_STAGE_MASTER_LIST_FAILURE: 'GET_LEAD_STAGE_MASTER_LIST_FAILURE',

    ADD_LEAD_STAGE_MASTER_REQUEST: 'POST_ADD_LEAD_STAGE_MASTER_REQUEST',
    ADD_LEAD_STAGE_MASTER_SUCCESS: 'POST_ADD_LEAD_STAGE_MASTER_SUCCESS',
    ADD_LEAD_STAGE_MASTER_FAILURE: 'POST_ADD_LEAD_STAGE_MASTER_FAILURE',
    ADD_LEAD_STAGE_MASTER_RESET: 'POST_ADD_LEAD_STAGE_MASTER_RESET',

    SOLD_MANAGEMENT_ITEM_ID_REQUEST: 'GET_SOLD_MANAGEMENT_ITEM_ID_REQUEST',
    SOLD_MANAGEMENT_ITEM_ID_SUCCESS: 'GET_SOLD_MANAGEMENT_ITEM_ID_SUCCESS',
    SOLD_MANAGEMENT_ITEM_ID_FAILURE: 'GET_SOLD_MANAGEMENT_ITEM_ID_FAILURE',

    UPDATE_SOLD_MANAGMENT_REQUEST: 'PUT_UPDATE_SOLD_MANAGMENT_REQUEST',
    UPDATE_SOLD_MANAGMENT_SUCCESS: 'PUT_UPDATE_SOLD_MANAGMENT_SUCCESS',
    UPDATE_SOLD_MANAGMENT_FAILURE: 'PUT_UPDATE_SOLD_MANAGMENT_FAILURE',

    GET_ROLE_LIST_REQUEST: 'GET_ROLE_DROP_LIST_REQUEST',
    GET_ROLE_LIST_SUCCESS: 'GET_ROLE_DROP_LIST_SUCCESS',
    GET_ROLE_LIST_FAILURE: 'GET_ROLE_DROP_LIST_FAILURE',

    GET_REGION_LIST_REQUEST: 'GET_REGION_LIST_REQUEST',
    GET_REGION_LIST_SUCCESS: 'GET_REGION_LIST_SUCCESS',
    GET_REGION_LIST_FAILURE: 'GET_REGION_LIST_FAILURE',

    GET_PROVINCE_LIST_REQUEST: 'GET_PROVINCE_LIST_REQUEST',
    GET_PROVINCE_LIST_SUCCESS: 'GET_PROVINCE_LIST_SUCCESS',
    GET_PROVINCE_LIST_FAILURE: 'GET_PROVINCE_LIST_FAILURE',

    GET_DISTRICT_LIST_REQUEST: 'GET_DISTRICT_LIST_REQUEST',
    GET_DISTRICT_LIST_SUCCESS: 'GET_DISTRICT_LIST_SUCCESS',
    GET_DISTRICT_LIST_FAILURE: 'GET_DISTRICT_LIST_FAILURE',

    REGION_SELECT_VALUE_REQUEST: 'GET_REGION_SELECT_VALUE_REQUEST',
    REGION_SELECT_VALUE_SUCCESS: 'GET_REGION_SELECT_VALUE_SUCCESS',
    REGION_SELECT_VALUE_FAILURE: 'GET_REGION_SELECT_VALUE_FAILURE',

    PROVINCE_SELECT_VALUE_REQUEST: 'GET_PROVINCE_SELECT_VALUE_REQUEST',
    PROVINCE_SELECT_VALUE_SUCCESS: 'GET_PROVINCE_SELECT_VALUE_SUCCESS',
    PROVINCE_SELECT_VALUE_FAILURE: 'GET_PROVINCE_SELECT_VALUE_FAILURE',

    GET_SEGMENT_LIST_REQUEST: 'GET_SEGMENT_LIST_REQUEST',
    GET_SEGMENT_LIST_SUCCESS: 'GET_SEGMENT_LIST_SUCCESS',
    GET_SEGMENT_LIST_FAILURE: 'GET_SEGMENT_LIST_FAILURE',

    GET_ALL_USER_LIST_REQUEST: 'GET_ALL_USER_LIST_REQUEST',
    GET_ALL_USER_LIST_SUCCESS: 'GET_ALL_USER_LIST_SUCCESS',
    GET_ALL_USER_LIST_FAILURE: 'GET_ALL_USER_LIST_FAILURE',

    GET_SUB_DISTRICT_LIST_REQUEST: 'GET_SUB_DISTRICT_LIST_REQUEST',
    GET_SUB_DISTRICT_LIST_SUCCESS: 'GET_SUB_DISTRICT_LIST_SUCCESS',
    GET_SUB_DISTRICT_LIST_FAILURE: 'GET_SUB_DISTRICT_LIST_FAILURE',

    DISTRICT_SELECT_VALUE_REQUEST: 'GET_DISTRICT_SELECT_VALUE_REQUEST',
    DISTRICT_SELECT_VALUE_SUCCESS: 'GET_DISTRICT_SELECT_VALUE_SUCCESS',
    DISTRICT_SELECT_VALUE_FAILURE: 'GET_DISTRICT_SELECT_VALUE_FAILURE',

    SUB_DISTRICT_SELECT_VALUE_REQUEST: 'GET_SUB_DISTRICT_SELECT_VALUEE_REQUEST',
    SUB_DISTRICT_SELECT_VALUE_SUCCESS: 'GET_SUB_DISTRICT_SELECT_VALUE_SUCCESS',
    SUB_DISTRICT_SELECT_VALUE_FAILURE: 'GET_SUB_DISTRICT_SELECT_VALUE_FAILURE',

    GET_ASSIGN_PRODUCT_GROUP_DETAIL_REQUEST: 'GET_ASSIGN_PRODUCT_GROUP_DETAIL_REQUEST',
    GET_ASSIGN_PRODUCT_GROUP_DETAIL_SUCCESS: 'GET_ASSIGN_PRODUCT_GROUP_DETAIL_SUCCESS',
    GET_ASSIGN_PRODUCT_GROUP_DETAIL_FAILURE: 'GET_ASSIGN_PRODUCT_GROUP_DETAIL_FAILURE',
    GET_ASSIGN_PRODUCT_GROUP_DETAIL_CLEAR_STATE: 'GET_ASSIGN_PRODUCT_GROUP_DETAIL_CLEAR_STATE',

    GET_GEOGRAPHY_MASTER_LIST_REQUEST: 'GET_GEOGRAPHY_MASTER_LIST_REQUEST',
    GET_GEOGRAPHY_MASTER_LIST_SUCCESS: 'GET_GEOGRAPHY_MASTER_LIST_SUCCESS',
    GET_GEOGRAPHY_MASTER_LIST_FAILURE: 'GET_GEOGRAPHY_MASTER_LIST_FAILURE',

    GET_PRODUCT_IMAGE_LIST_REQUEST: 'GET_PRODUCT_IMAGE_LIST_REQUEST',
    GET_PRODUCT_IMAGE_LIST_SUCCESS: 'GET_PRODUCT_IMAGE_LIST_SUCCESS',
    GET_PRODUCT_IMAGE_LIST_FAILURE: 'GET_PRODUCT_IMAGE_LIST_FAILURE',

    GET_SOLD_TO_SEARCH_REQUEST: 'GET_SOLD_TO_SEARCH_REQUEST',
    GET_SOLD_TO_SEARCH_SUCCESS: 'GET_SOLD_TO_SEARCH_SUCCESS',
    GET_SOLD_TO_SEARCH_FAILURE: 'GET_SOLD_TO_SEARCH_FAILURE',
    GET_SOLD_TO_SEARCH_CLEAR_STATE: 'GET_SOLD_TO_SEARCH_CLEAR_STATE',

    ACCOUNT_FORM_DATA_REQUEST: "POST_ACCOUNT_FORM_DATA_REQUEST",
    ACCOUNT_FORM_DATA_SUCCESS: "POST_ACCOUNT_FORM_DATA_SUCCESS",
    ACCOUNT_FORM_DATA_FAILURE: "POST_ACCOUNT_FORM_DATA_FAILURE",
    ACCOUNT_FORM_DATA_CLEAR: 'ACCOUNT_FORM_DATA_CLEAR',

    GET_PRODUCT_ACTIVE_ASSIGN_LIST_REQUEST: 'GET_PRODUCT_ACTIVE_ASSIGN_LIST_REQUEST',
    GET_PRODUCT_ACTIVE_ASSIGN_LIST_SUCCESS: 'GET_PRODUCT_ACTIVE_ASSIGN_LIST_SUCCESS',
    GET_PRODUCT_ACTIVE_ASSIGN_LIST_FAILURE: 'GET_PRODUCT_ACTIVE_ASSIGN_LIST_FAILURE',

    PRODUCT_MASTER_ACTIVE_INACTIVE_REQUEST: "PUT_PRODUCT_MASTER_ACTIVE_INACTIVE_REQUEST",
    PRODUCT_MASTER_ACTIVE_INACTIVE_SUCCESS: "PUT_PRODUCT_MASTER_ACTIVE_INACTIVE_SUCCESS",
    PRODUCT_MASTER_ACTIVE_INACTIVE_FAILURE: "PUT_PRODUCT_MASTER_ACTIVE_INACTIVE_FAILURE",

    ACTIVE_PRODUCT_MASTER_REQUEST: 'GET_ACTIVE_PRODUCT_MASTER_REQUEST',
    ACTIVE_PRODUCT_MASTER_SUCCESS: 'GET_ACTIVE_PRODUCT_MASTER_SUCCESS',
    ACTIVE_PRODUCT_MASTER_FAILURE: 'GET_ACTIVE_PRODUCT_MASTER_FAILURE',

    SOLD_PRODUCTGROUP_LIST_REQUEST: 'POST_SOLD_PRODUCTGROUP_LIST_REQUEST',
    SOLD_PRODUCTGROUP_LIST_SUCCESS: 'POST_SOLD_PRODUCTGROUP_LIST_SUCCESS',
    SOLD_PRODUCTGROUP_LIST_FAILURE: 'POST_SOLD_PRODUCTGROUP_LIST_FAILURE',

    GET_CUSTOMER_GROUP_LIST_REQUEST: 'GET_CUSTOMER_GROUP_LIST_REQUEST',
    GET_CUSTOMER_GROUP_LIST_SUCCESS: 'GET_CUSTOMER_GROUP_LIST_SUCCESS',
    GET_CUSTOMER_GROUP_LIST_FAILURE: 'GET_CUSTOMER_GROUP_LIST_FAILURE',

    ADD_CUSTOMER_GROUP_REQUEST: 'ADD_CUSTOMER_GROUP_REQUEST',
    ADD_CUSTOMER_GROUP_SUCCESS: 'ADD_CUSTOMER_GROUP_SUCCESS',
    ADD_CUSTOMER_GROUP_FAILURE: 'ADD_CUSTOMER_GROUP_FAILURE',

    TRUCK_MASTER_LIST_REQUEST: 'GET_TRUCK_MASTER_LIST_REQUEST',
    TRUCK_MASTER_LIST_SUCCESS: 'GET_TRUCK_MASTER_LIST_SUCCESS',
    TRUCK_MASTER_LIST_FAILURE: 'GET_TRUCK_MASTER_LIST_FAILURE',

    SOLD_SHIP_TO_LIST_REQUEST: 'GET_SOLD_SHIP_TO_LIST_REQUEST',
    SOLD_SHIP_TO_LIST_SUCCESS: 'GET_SOLD_SHIP_TO_LIST_SUCCESS',
    SOLD_SHIP_TO_LIST_FAILURE: 'GET_SOLD_SHIP_TO_LIST_FAILURE',

    SOLD_CONTRACT_LIST_REQUEST: 'GET_SOLD_CONTRACT_LIST_REQUEST',
    SOLD_CONTRACT_LIST_SUCCESS: 'GET_SOLD_CONTRACT_LIST_SUCCESS',
    SOLD_CONTRACT_LIST_FAILURE: 'GET_SOLD_CONTRACT_LIST_FAILURE',

    CONTRACT_DETAIL_LIST_REQUEST: 'GET_CONTRACT_DETAIL_LIST_REQUEST',
    CONTRACT_DETAIL_LIST_SUCCESS: 'GET_CONTRACT_DETAIL_LIST_SUCCESS',
    CONTRACT_DETAIL_LIST_FAILURE: 'GET_CONTRACT_DETAIL_LIST_FAILURE',

    INSEE_PRIVILAGE_LIST_REQUEST: 'GET_INSEE_PRIVILAGE_LIST_REQUEST',
    INSEE_PRIVILAGE_LIST_SUCCESS: 'GET_INSEE_PRIVILAGE_LIST_SUCCESS',
    INSEE_PRIVILAGE_LIST_FAILURE: 'GET_INSEE_PRIVILAGE_LIST_FAILURE',

    INSEE_PRIVILAGE_MONTH_YEAR_REQUEST: 'INSEE_PRIVILAGE_MONTH_YEAR_REQUEST',
    INSEE_PRIVILAGE_MONTH_YEAR_SUCCESS: 'INSEE_PRIVILAGE_MONTH_YEAR_SUCCESS',
    INSEE_PRIVILAGE_MONTH_YEAR_FAILURE: 'INSEE_PRIVILAGE_MONTH_YEAR_FAILURE',

    ADD_ROLE_REQUEST: 'POST_ADD_ROLE_REQUEST',
    ADD_ROLE_SUCCESS: 'POST_ADD_ROLE_SUCCESS',
    ADD_ROLE_FAILURE: 'POST_ADD_ROLE_FAILURE',

    GET_ALL_ROLE_LIST_REQUEST: 'GET_ALL_ROLE_LIST_REQUEST',
    GET_ALL_ROLE_LIST_SUCCESS: 'GET_ALL_ROLE_LIST_SUCCESS',
    GET_ALL_ROLE_LIST_FAILURE: 'GET_ALL_ROLE_LIST_FAILURE',


    ADD_TRUCK_MASTER_REQUEST: 'POST_ADD_TRUCK_MASTER_REQUEST',
    ADD_TRUCK_MASTER_SUCCESS: 'POST_ADD_TRUCK_MASTER_SUCCESS',
    ADD_TRUCK_MASTER_FAILURE: 'POST_ADD_TRUCK_MASTER_FAILURE',
    ADD_TRUCK_MASTER_CLEAR_TOAST: 'POST_ADD_TRUCK_MASTER_CLEAR_TOAST',


    GET_OWNERSHIP_LIST_REQUEST: 'GET_OWNERSHIP_LIST_REQUEST',
    GET_OWNERSHIP_LIST_SUCCESS: 'GET_OWNERSHIP_LIST_SUCCESS',
    GET_OWNERSHIP_LIST_FAILURE: 'GET_OWNERSHIP_LIST_FAILURE',

    VECHILE_STATUS_LIST_REQUEST: 'VECHILE_STATUS_LIST_REQUEST',
    VECHILE_STATUS_LIST_SUCCESS: 'VECHILE_STATUS_LIST_SUCCESS',
    VECHILE_STATUS_LIST_FAILURE: 'VECHILE_STATUS_LIST_FAILURE',


    VECHILE_TYPE_LIST_REQUEST: 'GET_VECHILE_TYPE_LIST_REQUEST',
    VECHILE_TYPE_LIST_SUCCESS: 'GET_VECHILE_TYPE_LIST_SUCCESS',
    VECHILE_TYPE_LIST_FAILURE: 'GET_VECHILE_TYPE_LIST_FAILURE',


    GUIDELINE_MATRIX_LIST_REQUEST: 'GUIDELINE_MATRIX_LIST_REQUEST',
    GUIDELINE_MATRIX_LIST_SUCCESS: 'GUIDELINE_MATRIX_LIST_SUCCESS',
    GUIDELINE_MATRIX_LIST_FAILURE: 'GUIDELINE_MATRIX_LIST_FAILURE',


    ACTIVE_TRUCK_MASTER_REQUEST: 'GET_ACTIVE_TRUCK_MASTER_REQUEST',
    ACTIVE_TRUCK_MASTER_SUCCESS: 'GET_ACTIVE_TRUCK_MASTER_SUCCESS',
    ACTIVE_TRUCK_MASTER_FAILURE: 'GET_ACTIVE_TRUCK_MASTER_FAILURE',

    UPDATE_TRUCK_MASTER_REQUEST: 'PUT_UPDATE_TRUCK_MASTER_REQUEST',
    UPDATE_TRUCK_MASTER_SUCCESS: 'PUT_UPDATE_TRUCK_MASTER_SUCCESS',
    UPDATE_TRUCK_MASTER_FAILURE: 'PUT_UPDATE_TRUCK_MASTER_FAILURE',
    UPDATE_TRUCK_MASTER_CLEAR_TOAST: 'PUT_UPDATE_TRUCK_MASTER_CLEAR_TOAST',

    UPLOAD_GUIDELINE_MATRIX_REQUEST: 'POST_UPLOAD_GUIDELINE_MATRIX_REQUEST',
    UPLOAD_GUIDELINE_MATRIX_SUCCESS: 'POST_UPLOAD_GUIDELINE_MATRIX_SUCCESS',
    UPLOAD_GUIDELINE_MATRIX_FAILURE: 'POST_UPLOAD_GUIDELINE_MATRIX_FAILURE',

    UPLOAD_RETAILER_REQUEST: 'POST_UPLOAD_RETAILER_REQUEST',
    UPLOAD_RETAILER_SUCCESS: 'POST_UPLOAD_RETAILER_SUCCESS',
    UPLOAD_RETAILER_FAILURE: 'POST_UPLOAD_RETAILER_FAILURE',

    UPLOAD_INSEE_PRIVILAGE_REQUEST: 'POST_UPLOAD_INSEE_PRIVILAGE_REQUEST',
    UPLOAD_INSEE_PRIVILAGE_SUCCESS: 'POST_UPLOAD_INSEE_PRIVILAGE_SUCCESS',
    UPLOAD_INSEE_PRIVILAGE_FAILURE: 'POST_UPLOAD_INSEE_PRIVILAGE_FAILURE',
    UPLOAD_INSEE_PRIVILAGE_CLEAR_TOAST: 'UPLOAD_INSEE_PRIVILAGE_CLEAR_TOAST',


    UPLOAD_CUSTOMER_TIER_REQUEST: 'POST_UPLOAD_CUSTOMER_TIER_REQUEST',
    UPLOAD_CUSTOMER_TIER_SUCCESS: 'POST_UPLOAD_CUSTOMER_TIER_SUCCESS',
    UPLOAD_CUSTOMER_TIER_FAILURE: 'POST_UPLOAD_CUSTOMER_TIER_FAILURE',

    STRATEGY_MATRIX_LIST_REQUEST: 'GET_STRATEGY_MATRIX_LIST_REQUEST',
    STRATEGY_MATRIX_LIST_SUCCESS: 'GET_STRATEGY_MATRIX_LIST_SUCCESS',
    STRATEGY_MATRIX_LIST_FAILURE: 'GET_STRATEGY_MATRIX_LIST_FAILURE',

    ADD_STRATEGY_MATRIX_REQUEST: 'POST_ADD_STRATEGY_MATRIX_REQUEST',
    ADD_STRATEGY_MATRIX_SUCCESS: 'POST_ADD_STRATEGY_MATRIX_SUCCESS',
    ADD_STRATEGY_MATRIX_FAILURE: 'POST_ADD_STRATEGY_MATRIX_FAILURE',

    INTERNAL_MANAGMENT_FILTER_REQUEST: 'GET_INTERNAL_MANAGMENT_FILTER_REQUEST',
    INTERNAL_MANAGMENT_FILTER_SUCCESS: 'GET_INTERNAL_MANAGMENT_FILTER_SUCCESS',
    INTERNAL_MANAGMENT_FILTER_FAILURE: 'GET_INTERNAL_MANAGMENT_FILTER_FAILURE',

    ROLE_SELECT_VALUE_REQUEST: 'GET_ROLE_SELECT_VALUE_REQUEST',
    ROLE_SELECT_VALUE_SUCCESS: 'GET_ROLE_SELECT_VALUE_SUCCESS',
    ROLE_SELECT_VALUE_FAILURE: 'GET_ROLE_SELECT_VALUE_FAILURE',

    INTERNAL_MANAGMENT_SEARCH_REQUEST: 'GET_INTERNAL_MANAGMENT_SEARCH_REQUEST',
    INTERNAL_MANAGMENT_SEARCH_SUCCESS: 'GET_INTERNAL_MANAGMENT_SEARCH_SUCCESS',
    INTERNAL_MANAGMENT_SEARCH_FAILURE: 'GET_INTERNAL_MANAGMENT_SEARCH_FAILURE',
    INTERNAL_MANAGMENT_SEARCH_CLEAR_STATE: 'INTERNAL_MANAGMENT_SEARCH_CLEAR_STATE',

    CUSTOMER_TIER_LIST_REQUEST: 'GET_CUSTOMER_TIER_LIST_REQUEST',
    CUSTOMER_TIER_LIST_SUCCESS: 'GET_CUSTOMER_TIER_LIST_SUCCESS',
    CUSTOMER_TIER_LIST_FAILURE: 'GET_CUSTOMER_TIER_LIST_FAILURE',

    CUSTOMER_USERID_REQUEST: 'GET_CUSTOMER_USERID_REQUEST',
    CUSTOMER_USERID_SUCCESS: 'GET_CUSTOMER_USERID_SUCCESS',
    CUSTOMER_USERID_FAILURE: 'GET_CUSTOMER_USERID_FAILURE',

    RETAILER_LIST_REQUEST: 'GET_RETAILER_LIST_REQUEST',
    RETAILER_LIST_SUCCESS: 'GET_RETAILER_LIST_SUCCESS',
    RETAILER_LIST_FAILURE: 'GET_RETAILER_LIST_FAILURE',

    LOYALTY_CUSTOMER_LIST_REQUEST: 'GET_LOYALTY_CUSTOMER_LIST_REQUEST',
    LOYALTY_CUSTOMER_LIST_SUCCESS: 'GET_LOYALTY_CUSTOMER_LIST_SUCCESS',
    LOYALTY_CUSTOMER_LIST_FAILURE: 'GET_LOYALTY_CUSTOMER_LIST_FAILURE',

    LOYALTY_POINT_FORM_REQUEST: 'POST_LOYALTY_POINT_FORM_REQUEST',
    LOYALTY_POINT_FORM_SUCCESS: 'POST_LOYALTY_POINT_FORM_SUCCESS',
    LOYALTY_POINT_FORM_FAILURE: 'POST_LOYALTY_POINT_FORM_FAILURE',
    LOYALTY_POINT_FORM_CLEAR_TOAST: 'LOYALTY_POINT_FORM_CLEAR_TOAST',

    LOYALTY_POINT_LIST_REQUEST: 'GET_LOYALTY_POINT_LIST_REQUEST',
    LOYALTY_POINT_LIST_SUCCESS: 'GET_LOYALTY_POINT_LIST_SUCCESS',
    LOYALTY_POINT_LIST_FAILURE: 'GET_LOYALTY_POINT_LIST_FAILURE',

    PRODUCT_CLASSIFICATION_LIST_REQUEST: 'GET_PRODUCT_CLASSIFICATION_LIST_REQUEST',
    PRODUCT_CLASSIFICATION_LIST_SUCCESS: 'GET_PRODUCT_CLASSIFICATION_LIST_SUCCESS',
    PRODUCT_CLASSIFICATION_LIST_FAILURE: 'GET_PRODUCT_CLASSIFICATION_LIST_FAILURE',

    ADD_PRODUCT_CLASSIFICATION_REQUEST: 'POST_ADD_PRODUCT_CLASSIFICATION_REQUEST',
    ADD_PRODUCT_CLASSIFICATION_SUCCESS: 'POST_ADD_PRODUCT_CLASSIFICATION_SUCCESS',
    ADD_PRODUCT_CLASSIFICATION_FAILURE: 'POST_ADD_PRODUCT_CLASSIFICATION_FAILURE',


    PRODUCT_GROUP_EDIT_LIST_REQUEST: 'GET_PRODUCT_GROUP_EDIT_LIST_REQUEST',
    PRODUCT_GROUP_EDIT_LIST_SUCCESS: 'GET_PRODUCT_GROUP_EDIT_LIST_SUCCESS',
    PRODUCT_GROUP_EDIT_LIST_FAILURE: 'GET_PRODUCT_GROUP_EDIT_LIST_FAILURE',

    DELETE_ASSIGN_PRODUCT_REQUEST: 'DELETE_ASSIGN_PRODUCT_REQUEST',
    DELETE_ASSIGN_PRODUCT_SUCCESS: 'DELETE_ASSIGN_PRODUCT_SUCCESS',
    DELETE_ASSIGN_PRODUCT_FAILURE: 'DELETE_ASSIGN_PRODUCT_FAILURE',

    DELETE_SOLDTO_PRODUCT_REQUEST: 'DELETE_SOLDTO_PRODUCT_REQUEST',
    DELETE_SOLDTO_PRODUCT_SUCCESS: 'DELETE_SOLDTO_PRODUCT_SUCCESS',
    DELETE_SOLDTO_PRODUCT_FAILURE: 'DELETE_SOLDTO_PRODUCT_FAILURE',

    MODIFIED_PRODUCT_GROUP_REQUEST: 'PUT_MODIFIED_PRODUCT_GROUP_REQUEST',
    MODIFIED_PRODUCT_GROUP_SUCCESS: 'PUT_MODIFIED_PRODUCT_GROUP_SUCCESS',
    MODIFIED_PRODUCT_GROUP_FAILURE: 'PUT_MODIFIED_PRODUCT_GROUP_FAILURE',
    MODIFIED_PRODUCT_GROUP_CLEAN_TOAST: 'MODIFIED_PRODUCT_GROUP_CLEAN_TOAST',

    VECHILE_ID_LIST_REQUEST: 'GET_VECHILE_ID_LIST_REQUEST',
    VECHILE_ID_LIST_SUCCESS: 'GET_VECHILE_ID_LIST_SUCCESS',
    VECHILE_ID_LIST_FAILURE: 'GET_VECHILE_ID_LIST_FAILURE',

    APP_TYPE_REQUEST: 'GET_APP_TYPE_REQUEST',
    APP_TYPE_SUCCESS: 'GET_APP_TYPE_SUCCESS',
    APP_TYPE_FAILURE: 'GET_APP_TYPE_FAILURE',

    CUSTOMER_TYPE_REQUEST: 'GET_CUSTOMER_TYPE_REQUEST',
    CUSTOMER_TYPE_SUCCESS: 'GET_CUSTOMER_TYPE_SUCCESS',
    CUSTOMER_TYPE_FAILURE: 'GET_CUSTOMER_TYPE_FAILURE',

    ADD_BANNER_IMAGE_REQUEST: 'POST_ADD_BANNER_IMAGE_REQUEST',
    ADD_BANNER_IMAGE_SUCCESS: 'POST_ADD_BANNER_IMAGE_SUCCESS',
    ADD_BANNER_IMAGE_FAILURE: 'POST_ADD_BANNER_IMAGE_FAILURE',
    ADD_BANNER_IMAGE_CLEAR_TOAST: 'POST_ADD_BANNER_IMAGE_CLEAR_TOAST',

    BANNER_IMAGE_LIST_REQUEST: 'GET_BANNER_IMAGE_LIST_REQUEST',
    BANNER_IMAGE_LIST_SUCCESS: 'GET_BANNER_IMAGE_LIST_SUCCESS',
    BANNER_IMAGE_LIST_FAILURE: 'GET_BANNER_IMAGE_LIST_FAILURE',

    SEARCH_RETAILER_REQUEST: 'SEARCH_RETAILER_REQUEST',
    SEARCH_RETAILER_SUCCESS: 'SEARCH_RETAILER_SUCCESS',
    SEARCH_RETAILER_FAILURE: 'SEARCH_RETAILER_FAILURE',

    GET_RETAILER_DATA_REQUEST: 'GET_RETAILER_DATA_REQUEST',
    GET_RETAILER_DATA_SUCCESS: 'GET_RETAILER_DATA_SUCCESS',
    GET_RETAILER_DATA_FAILURE: 'GET_RETAILER_DATA_FAILURE',


    PRODUCT_MASTER_DELETE_GROUP_REQUEST: 'DELETE_PRODUCT_MASTER_DELETE_GROUP_REQUEST',
    PRODUCT_MASTER_DELETE_GROUP_SUCCESS: 'DELETE_PRODUCT_MASTER_DELETE_GROUP_SUCCESS',
    PRODUCT_MASTER_DELETE_GROUP_FAILURE: 'DELETE_PRODUCT_MASTER_DELETE_GROUP_FAILURE',


    ADD_CONWOOD_MASTER_REQUEST: 'POST_ADD_CONWOOD_MASTER_REQUEST',
    ADD_CONWOOD_MASTER_SUCCESS: 'POST_ADD_CONWOOD_MASTER_SUCCESS',
    ADD_CONWOOD_MASTER_FAILURE: 'POST_ADD_CONWOOD_MASTER_FAILURE',
    ADD_CONWOOD_MASTER_CLEAR_STATE: 'ADD_CONWOOD_MASTER_CLEAR_STATE',



    DROPDOWN_PARENT_CATEGORY_REQUEST: 'GET_DROPDOWN_PARENT_CATEGORY_REQUEST',
    DROPDOWN_PARENT_CATEGORY_SUCCESS: 'GET_DROPDOWN_PARENT_CATEGORY_SUCCESS',
    DROPDOWN_PARENT_CATEGORY_FAILURE: 'GET_DROPDOWN_PARENT_CATEGORY_FAILURE',


    CONWOOD_CATEGORY_LIST_REQUEST: 'GET_CONWOOD_CATEGORY_LIST_REQUEST',
    CONWOOD_CATEGORY_LIST_SUCCESS: 'GET_CONWOOD_CATEGORY_LIST_SUCCESS',
    CONWOOD_CATEGORY_LIST_FAILURE: 'GET_CONWOOD_CATEGORY_LIST_FAILURE',

    DELETE_CATEGORY_LIST_REQUEST: 'DELETE_CATEGORY_LIST_REQUEST',
    DELETE_CATEGORY_LIST_SUCCESS: 'DELETE_CATEGORY_LIST_SUCCESS',
    DELETE_CATEGORY_LIST_FAILURE: 'DELETE_CATEGORY_LIST_FAILURE',

    UPLOAD_PRODUCT_GROUP_REQUEST: 'PUT_UPLOAD_PRODUCT_GROUP_REQUEST',
    UPLOAD_PRODUCT_GROUP_SUCCESS: 'PUT_UPLOAD_PRODUCT_GROUP_SUCCESS',
    UPLOAD_PRODUCT_GROUP_FAILURE: 'PUT_UPLOAD_PRODUCT_GROUP_FAILURE',

    UPLOAD_SOLDTO_MANAGEMENT_REQUEST: 'POST_UPLOAD_SOLDTO_MANAGEMENT_REQUEST',
    UPLOAD_SOLDTO_MANAGEMENT_SUCCESS: 'POST_UPLOAD_SOLDTO_MANAGEMENT_SUCCESS',
    UPLOAD_SOLDTO_MANAGEMENT_FAILURE: 'POST_UPLOAD_SOLDTO_MANAGEMENT_FAILURE',
    UPLOAD_SOLDTO_MANAGEMENT_CLEAR_TOAST: 'POST_UPLOAD_SOLDTO_MANAGEMENT_CLEAR_TOAST',


    UPDATE_ACCOUNT_LIST_REQUEST: 'PUT_UPDATE_ACCOUNT_LIST_REQUEST',
    UPDATE_ACCOUNT_LIST_SUCCESS: 'PUT_UPDATE_ACCOUNT_LIST_SUCCESS',
    UPDATE_ACCOUNT_LIST_FAILURE: 'PUT_UPDATE_ACCOUNT_LIST_FAILURE',
    UPDATE_ACCOUNT_LIST_CLEAR: 'UPDATE_ACCOUNT_LIST_CLEAR',


    CONTACT_USERID_REQUEST: 'GET_CONTACT_USERID_REQUEST',
    CONTACT_USERID_SUCCESS: 'GET_CONTACT_USERID_SUCCESS',
    CONTACT_USERID_FAILURE: 'GET_CONTACT_USERID_FAILURE',

    UPDATE_CONTACT_TOGGLE_REQUEST: 'PUT_UPDATE_CONTACT_TOGGLE_REQUEST',
    UPDATE_CONTACT_TOGGLE_SUCCESS: 'PUT_UPDATE_CONTACT_TOGGLE_SUCCESS',
    UPDATE_CONTACT_TOGGLE_FAILURE: 'PUT_UPDATE_CONTACT_TOGGLE_FAILURE',

    AUTO_FILL_CONTACT_FORM_REQUEST: 'GET_AUTO_FILL_CONTACT_FORM_REQUEST',
    AUTO_FILL_CONTACT_FORM_SUCCESS: 'GET_AUTO_FILL_CONTACT_FORM_SUCCESS',
    AUTO_FILL_CONTACT_FORM_FAILURE: 'GET_AUTO_FILL_CONTACT_FORM_FAILURE',

    DOWNLOAD_SOLDTO_REQUEST: 'GET_DOWNLOAD_SOLDTO_REQUEST',
    DOWNLOAD_SOLDTO_SUCCESS: 'GET_DOWNLOAD_SOLDTO_SUCCESS',
    DOWNLOAD_SOLDTO_FAILURE: 'GET_DOWNLOAD_SOLDTO_FAILURE',

    
    DOWNLOAD_CONTACT_REQUEST: 'GET_DOWNLOAD_CONTACT_REQUEST',
    DOWNLOAD_CONTACT_SUCCESS: 'GET_DOWNLOAD_CONTACT_SUCCESS',
    DOWNLOAD_CONTACT_FAILURE: 'GET_DOWNLOAD_CONTACT_FAILURE',

    DELETE_BANNER_LIST_REQUEST: 'DELETE_BANNER_LIST_REQUEST',
    DELETE_BANNER_LIST_SUCCESS: 'DELETE_BANNER_LIST_SUCCESS',
    DELETE_BANNER_LIST_FAILURE: 'DELETE_BANNER_LIST_FAILURE',
    DELETE_BANNER_CLEAN_TOAST: 'DELETE_BANNER_CLEAN_TOAST',


    EDIT_BANNER_LIST_REQUEST: 'EDIT_BANNER_LIST_REQUEST',
    EDIT_BANNER_LIST_SUCCESS: 'EDIT_BANNER_LIST_SUCCESS',
    EDIT_BANNER_LIST_FAILURE: 'EDIT_BANNER_LIST_FAILURE',
    EDIT_BANNER_LIST_CLEAR_TOAST: 'EDIT_BANNER_LIST_CLEAR_TOAST',

    EDIT_DASHBOARD_IMAGE_REQUEST: 'EDIT_DASHBOARD_IMAGE_REQUEST',
    EDIT_DASHBOARD_IMAGE_SUCCESS: 'EDIT_DASHBOARD_IMAGE_SUCCESS',
    EDIT_DASHBOARD_IMAGE_FAILURE: 'EDIT_DASHBOARD_IMAGE_FAILURE',

    DOWNLOAD_PRODUCT_GROUP_REQUEST: 'GET_DOWNLOAD_PRODUCT_GROUP_REQUEST',
    DOWNLOAD_PRODUCT_GROUP_SUCCESS: 'GET_DOWNLOAD_PRODUCT_GROUP_SUCCESS',
    DOWNLOAD_PRODUCT_GROUP_FAILURE: 'GET_DOWNLOAD_PRODUCT_GROUP_FAILURE',

    CONTRACT_LIST_SEARCH_REQUEST: 'GET_CONTRACT_LIST_SEARCH_REQUEST',
    CONTRACT_LIST_SEARCH_SUCCESS: 'GET_CONTRACT_LIST_SEARCH_SUCCESS',
    CONTRACT_LIST_SEARCH_FAILURE: 'GET_CONTRACT_LIST_SEARCH_FAILURE',

    DOWNLOAD_INSEE_PRIVILEGE_REQUEST: 'GET_DOWNLOAD_INSEE_PRIVILEGE_REQUEST',
    DOWNLOAD_INSEE_PRIVILEGE_SUCCESS: 'GET_DOWNLOAD_INSEE_PRIVILEGE_SUCCESS',
    DOWNLOAD_INSEE_PRIVILEGE_FAILURE: 'GET_DOWNLOAD_INSEE_PRIVILEGE_FAILURE',

    DOWNLOAD_CUSTOMER_TIER_REQUEST: 'GET_DOWNLOAD_CUSTOMER_TIER_REQUEST',
    DOWNLOAD_CUSTOMER_TIER_SUCCESS: 'GET_DOWNLOAD_CUSTOMER_TIER_SUCCESS',
    DOWNLOAD_CUSTOMER_TIER_FAILURE: 'GET_DOWNLOAD_CUSTOMER_TIER_FAILURE',

    SHIP_TO_SEARCH_REQUEST: 'GET_SHIP_TO_SEARCH_REQUEST',
    SHIP_TO_SEARCH_SUCCESS: 'GET_SHIP_TO_SEARCH_SUCCESS',
    SHIP_TO_SEARCH_FAILURE: 'GET_SHIP_TO_SEARCH_FAILURE',

    TRUCK_MASTER_SEARCH_REQUEST: 'GET_TRUCK_MASTER_SEARCH_REQUEST',
    TRUCK_MASTER_SEARCH_SUCCESS: 'GET_TRUCK_MASTER_SEARCH_SUCCESS',
    TRUCK_MASTER_SEARCH_FAILURE: 'GET_TRUCK_MASTER_SEARCH_FAILURE',

    SUB_DEALER_SEARCH_REQUEST: 'GET_SUB_DEALER_SEARCH_REQUEST',
    SUB_DEALER_SEARCH_SUCCESS: 'GET_SUB_DEALER_SEARCH_SUCCESS',
    SUB_DEALER_SEARCH_FAILURE: 'GET_SUB_DEALER_SEARCH_FAILURE',

    CONTACT_LIST_SEARCH_REQUEST: 'GET_CONTACT_LIST_SEARCH_REQUEST',
    CONTACT_LIST_SEARCH_SUCCESS: 'GET_CONTACT_LIST_SEARCH_SUCCESS',
    CONTACT_LIST_SEARCH_FAILURE: 'GET_CONTACT_LIST_SEARCH_FAILURE',

    UPLOAD_CONTACT_REQUEST: 'GET_UPLOAD_CONTACT_REQUEST',
    UPLOAD_CONTACT_SUCCESS: 'GET_UPLOAD_CONTACT_SUCCESS',
    UPLOAD_CONTACT_FAILURE: 'GET_UPLOAD_CONTACT_FAILURE',
    UPLOAD_CONTACT_CLEAR_TOAST: 'UPLOAD_CONTACT_CLEAR_TOAST',

    DOWNLOAD_CONTACT_DETAILS_REQUEST: 'GET_DOWNLOAD_CONTACT_DETAILS_REQUEST',
    DOWNLOAD_CONTACT_DETAILS_SUCCESS: 'GET_DOWNLOAD_CONTACT_DETAILS_SUCCESS',
    DOWNLOAD_CONTACT_DETAILS_FAILURE: 'GET_DOWNLOAD_CONTACT_DETAILS_FAILURE',

    DELETE_PRODUCT_GROUP_LIST_REQUEST: 'DELETE_PRODUCT_GROUP_LIST_REQUEST',
    DELETE_PRODUCT_GROUP_LIST_SUCCESS: 'DELETE_PRODUCT_GROUP_LIST_SUCCESS',
    DELETE_PRODUCT_GROUP_LIST_FAILURE: 'DELETE_PRODUCT_GROUP_LIST_FAILURE',

    UPDATE_CUSTOMER_TIER_REQUEST: 'PUT_UPDATE_CUSTOMER_TIER_REQUEST',
    UPDATE_CUSTOMER_TIER_SUCCESS: 'PUT_UPDATE_CUSTOMER_TIER_SUCCESS',
    UPDATE_CUSTOMER_TIER_FAILURE: 'PUT_UPDATE_CUSTOMER_TIER_FAILURE',

    CUSTOMER_AUTO_TIER_REQUEST: 'GET_CUSTOMER_AUTO_TIER_REQUEST',
    CUSTOMER_AUTO_TIER_SUCCESS: 'GET_CUSTOMER_AUTO_TIER_SUCCESS',
    CUSTOMER_AUTO_TIER_FAILURE: 'GET_CUSTOMER_AUTO_TIER_FAILURE',


    UPDATE_INSEE_PRIVILEGE_REQUEST: 'PUT_UPDATE_INSEE_PRIVILEGE_REQUEST',
    UPDATE_INSEE_PRIVILEGE_SUCCESS: 'PUT_UPDATE_INSEE_PRIVILEGE_SUCCESS',
    UPDATE_INSEE_PRIVILEGE_FAILURE: 'PUT_UPDATE_INSEE_PRIVILEGE_FAILURE',

    INSEE_AUTO_PRIVILEGE_REQUEST: 'GET_INSEE_AUTO_PRIVILEGE_REQUEST',
    INSEE_AUTO_PRIVILEGE_SUCCESS: 'GET_INSEE_AUTO_PRIVILEGE_SUCCESS',
    INSEE_AUTO_PRIVILEGE_FAILURE: 'GET_INSEE_AUTO_PRIVILEGE_FAILURE',

    DELETE_CONTACT_LIST_REQUEST: 'DELETE_CONTACT_LIST_REQUEST',
    DELETE_CONTACT_LIST_SUCCESS: 'DELETE_CONTACT_LIST_SUCCESS',
    DELETE_CONTACT_LIST_FAILURE: 'DELETE_CONTACT_LIST_FAILURE',
    
    RETAILER_DETAIL_LIST_REQUEST: 'GET_RETAILER_DETAIL_LIST_REQUEST',
    RETAILER_DETAIL_LIST_SUCCESS: 'GET_RETAILER_DETAIL_LIST_SUCCESS',
    RETAILER_DETAIL_LIST_FAILURE: 'GET_RETAILER_DETAIL_LIST_FAILURE',
    RETAILER_DETAIL_LIST_CLEAR_STATE: 'RETAILER_DETAIL_LIST_CLEAR_STATE',


    RETAILER_AUTO_LIST_REQUEST: 'GET_RETAILER_AUTO_LIST_REQUEST',
    RETAILER_AUTO_LIST_SUCCESS: 'GET_RETAILER_AUTO_LIST_SUCCESS',
    RETAILER_AUTO_LIST_FAILURE: 'GET_RETAILER_AUTO_LIST_FAILURE',

    UPDATE_RETAILER_LIST_REQUEST: 'PUT_UPDATE_RETAILER_LIST_REQUEST',
    UPDATE_RETAILER_LIST_SUCCESS: 'PUT_UPDATE_RETAILER_LIST_SUCCESS',
    UPDATE_RETAILER_LIST_FAILURE: 'PUT_UPDATE_RETAILER_LIST_FAILURE',
    UPDATE_RETAILER_LIST_CLEAR_TOAST: 'UPDATE_RETAILER_LIST_CLEAR_TOAST',

    
    DOWNLOAD_RETAILER_EXCEL_REQUEST: 'GET_DOWNLOAD_RETAILER_EXCEL_REQUEST',
    DOWNLOAD_RETAILER_EXCEL_SUCCESS: 'GET_DOWNLOAD_RETAILER_EXCEL_SUCCESS',
    DOWNLOAD_RETAILER_EXCEL_FAILURE: 'GET_DOWNLOAD_RETAILER_EXCEL_FAILURE',


    FILTER_PRODUCT_MASTER_REQUEST: 'GET_FILTER_PRODUCT_MASTER_REQUEST',
    FILTER_PRODUCT_MASTER_SUCCESS: 'GET_FILTER_PRODUCT_MASTER_SUCCESS',
    FILTER_PRODUCT_MASTER_FAILURE: 'GET_FILTER_PRODUCT_MASTER_FAILURE',

    
    DOWNLOAD_RETAILER_SUBDEALER_REQUEST: 'GET_DOWNLOAD_RETAILER_SUBDEALER_REQUEST',
    DOWNLOAD_RETAILER_SUBDEALER_SUCCESS: 'GET_DOWNLOAD_RETAILER_SUBDEALER_SUCCESS',
    DOWNLOAD_RETAILER_SUBDEALER_FAILURE: 'GET_DOWNLOAD_RETAILER_SUBDEALER_FAILURE',

    RESEND_LOGIN_CREDENTIAL_REQUEST: 'RESEND_LOGIN_CREDENTIAL_REQUEST',
    RESEND_LOGIN_CREDENTIAL_SUCCESS: 'RESEND_LOGIN_CREDENTIAL_SUCCESS',
    RESEND_LOGIN_CREDENTIAL_FAILURE: 'RESEND_LOGIN_CREDENTIAL_FAILURE',

    ASSIGN_PRODUCT_ITEM_ID_REQUEST: 'ASSIGN_PRODUCT_ITEM_ID_REQUEST',
    ASSIGN_PRODUCT_ITEM_ID_SUCCESS: 'ASSIGN_PRODUCT_ITEM_ID_SUCCESS',
    ASSIGN_PRODUCT_ITEM_ID_FAILURE: 'ASSIGN_PRODUCT_ITEM_ID_FAILURE',
    ASSIGN_PRODUCT_ITEM_ID_CLEAR_STATE: 'ASSIGN_PRODUCT_ITEM_ID_CLEAR_STATE',

    ASSIGN_PRODUCT_ADD_DATE_REQUEST: 'POST_ASSIGN_PRODUCT_ADD_DATE_REQUEST',
    ASSIGN_PRODUCT_ADD_DATE_SUCCESS: 'POST_ASSIGN_PRODUCT_ADD_DATE_SUCCESS',
    ASSIGN_PRODUCT_ADD_DATE_FAILURE: 'POST_ASSIGN_PRODUCT_ADD_DATE_FAILURE',
    ASSIGN_PRODUCT_ADD_DATE_CLEAR: 'ASSIGN_PRODUCT_ADD_DATE_CLEAR',

    ASSIGN_PRODUCT_UPDATE_DATE_REQUEST: 'POST_ASSIGN_PRODUCT_UPDATE_DATE_REQUEST',
    ASSIGN_PRODUCT_UPDATE_DATE_SUCCESS: 'POST_ASSIGN_PRODUCT_UPDATE_DATE_SUCCESS',
    ASSIGN_PRODUCT_UPDATE_DATE_FAILURE: 'POST_ASSIGN_PRODUCT_UPDATE_DATE_FAILURE',
    ASSIGN_PRODUCT_UPDATE_DATE_CLEAR_TOAST: 'ASSIGN_PRODUCT_UPDATE_DATE_CLEAR_TOAST',

    GET_ASSIGN_PRODUCT_DATE_REQUEST: 'GET_ASSIGN_PRODUCT_DATE_REQUEST',
    GET_ASSIGN_PRODUCT_DATE_SUCCESS: 'GET_ASSIGN_PRODUCT_DATE_SUCCESS',
    GET_ASSIGN_PRODUCT_DATE_FAILURE: 'GET_ASSIGN_PRODUCT_DATE_FAILURE',

    ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_REQUEST: 'POST_ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_REQUEST',
    ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_SUCCESS: 'POST_ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_SUCCESS',
    ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_FAILURE: 'POST_ASSIGN_SOLDTO_PRODUCT_UPDATE_DATE_FAILURE',

    GET_ASSIGN_SOLD_TO_DATE_REQUEST: 'GET_ASSIGN_SOLD_TO_DATE_REQUEST',
    GET_ASSIGN_SOLD_TO_DATE_SUCCESS: 'GET_ASSIGN_SOLD_TO_DATE_SUCCESS',
    GET_ASSIGN_SOLD_TO_DATE_FAILURE: 'GET_ASSIGN_SOLD_TO_DATE_FAILURE',
    
    ADD_PRODUCT_DATE_UNDER_SOLDTO_REQUEST: 'POST_ADD_PRODUCT_DATE_UNDER_SOLDTO_REQUEST',
    ADD_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS: 'POST_ADD_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS',
    ADD_PRODUCT_DATE_UNDER_SOLDTO_FAILURE: 'POST_ADD_PRODUCT_DATE_UNDER_SOLDTO_FAILURE',

    
    SOLDTO_ASSIGN_PRODUCT_REQUEST: 'SOLDTO_ASSIGN_PRODUCT_REQUEST',
    SOLDTO_ASSIGN_PRODUCT_SUCCESS: 'SOLDTO_ASSIGN_PRODUCT_SUCCESS',
    SOLDTO_ASSIGN_PRODUCT_FAILURE: 'SOLDTO_ASSIGN_PRODUCT_FAILURE',

    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_REQUEST: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_REQUEST',
    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS',
    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_FAILURE: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_FAILURE',

    
    GET_ASSIGN_PRODUCT_FOR_SOLDTO_REQUEST: 'GET_ASSIGN_PRODUCT_FOR_SOLDTO_REQUEST',
    GET_ASSIGN_PRODUCT_FOR_SOLDTO_SUCCESS: 'GET_ASSIGN_PRODUCT_FOR_SOLDTO_SUCCESS',
    GET_ASSIGN_PRODUCT_FOR_SOLDTO_FAILURE: 'GET_ASSIGN_PRODUCT_FOR_SOLDTO_FAILURE',


    DELETE_PRODUCT_DATE_SOLDTO_REQUEST: 'DELETE_PRODUCT_DATE_SOLDTO_REQUEST',
    DELETE_PRODUCT_DATE_SOLDTO_SUCCESS: 'DELETE_PRODUCT_DATE_SOLDTO_SUCCESS',
    DELETE_PRODUCT_DATE_SOLDTO_FAILURE: 'DELETE_PRODUCT_DATE_SOLDTO_FAILURE',

    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_REQUEST: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_REQUEST',
    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_SUCCESS',
    UPDATE_PRODUCT_DATE_UNDER_SOLDTO_FAILURE: 'UPDATE_PRODUCT_DATE_UNDER_SOLDTO_FAILURE',

    ASSIGNBY_PRODUCT_INSOLDTO_REQUEST: 'GET_ASSIGNBY_PRODUCT_INSOLDTO_REQUEST',
    ASSIGNBY_PRODUCT_INSOLDTO_SUCCESS: 'GET_ASSIGNBY_PRODUCT_INSOLDTO_SUCCESS',
    ASSIGNBY_PRODUCT_INSOLDTO_FAILURE: 'GET_ASSIGNBY_PRODUCT_INSOLDTO_FAILURE',

    
    UPLOAD_RETAILER_SUBDEALER_EXCEL_REQUEST: 'UPLOAD_RETAILER_SUBDEALER_EXCEL_REQUEST',
    UPLOAD_RETAILER_SUBDEALER_EXCEL_SUCCESS: 'UPLOAD_RETAILER_SUBDEALER_EXCEL_SUCCESS',
    UPLOAD_RETAILER_SUBDEALER_EXCEL_FAILURE: 'UPLOAD_RETAILER_SUBDEALER_EXCEL_FAILURE',
   
    UPLOAD_INSEE_VOLUME_EXCEL_REQUEST: 'POST_UPLOAD_INSEE_VOLUME_EXCEL_REQUEST',
    UPLOAD_INSEE_VOLUME_EXCEL_SUCCESS: 'POST_UPLOAD_INSEE_VOLUME_EXCEL_SUCCESS',
    UPLOAD_INSEE_VOLUME_EXCEL_FAILURE: 'POST_UPLOAD_INSEE_VOLUME_EXCEL_FAILURE',
    UPLOAD_INSEE_VOLUME_EXCEL_CLEARTOAST: 'UPLOAD_INSEE_VOLUME_EXCEL_CLEARTOAST',

    UPLOAD_LEAD_INSEE_VOLUME_REQUEST: 'POST_UPLOAD_LEAD_INSEE_VOLUME_REQUEST',
    UPLOAD_LEAD_INSEE_VOLUME_SUCCESS: 'POST_UPLOAD_LEAD_INSEE_VOLUME_SUCCESS',
    UPLOAD_LEAD_INSEE_VOLUME_FAILURE: 'POST_UPLOAD_LEAD_INSEE_VOLUME_FAILURE',
    UPLOAD_LEAD_INSEE_VOLUME_CLEAR_TOAST: 'UPLOAD_LEAD_INSEE_VOLUME_CLEAR_TOAST',

    UPLOAD_FORCAST_INSEE_VOLUME_REQUEST: 'POST_UPLOAD_FORCAST_INSEE_VOLUME_REQUEST',
    UPLOAD_FORCAST_INSEE_VOLUME_SUCCESS: 'POST_UPLOAD_FORCAST_INSEE_VOLUME_SUCCESS',
    UPLOAD_FORCAST_INSEE_VOLUME_FAILURE: 'POST_UPLOAD_FORCAST_INSEE_VOLUME_FAILURE',
    UPLOAD_FORCAST_INSEE_VOLUME_CLEAR_TOAST: 'UPLOAD_FORCAST_INSEE_VOLUME_CLEAR_TOAST',

    CONWOOD_AUTOFILL_CATEGORY_REQUEST: 'GET_CONWOOD_AUTOFILL_CATEGORY_REQUEST',
    CONWOOD_AUTOFILL_CATEGORY_SUCCESS: 'GET_CONWOOD_AUTOFILL_CATEGORY_SUCCESS',
    CONWOOD_AUTOFILL_CATEGORY_FAILURE: 'GET_CONWOOD_AUTOFILL_CATEGORY_FAILURE',

    TOTAL_INSEE_VOLUME_LIST_REQUEST: 'TOTAL_INSEE_VOLUME_LIST_REQUEST',
    TOTAL_INSEE_VOLUME_LIST_SUCCESS: 'TOTAL_INSEE_VOLUME_LIST_SUCCESS',
    TOTAL_INSEE_VOLUME_LIST_FAILURE: 'TOTAL_INSEE_VOLUME_LIST_FAILURE',

    UPDATE_CONWOOD_CATEGORY_REQUEST: 'UPDATE_CONWOOD_CATEGORY_REQUEST',
    UPDATE_CONWOOD_CATEGORY_SUCCESS: 'UPDATE_CONWOOD_CATEGORY_SUCCESS',
    UPDATE_CONWOOD_CATEGORY_FAILURE: 'UPDATE_CONWOOD_CATEGORY_FAILURE',

    SOLD_TO_ALL_EMAIL_REQUEST: 'POST_SOLD_TO_ALL_EMAIL_REQUEST',
    SOLD_TO_ALL_EMAIL_SUCCESS: 'POST_SOLD_TO_ALL_EMAIL_SUCCESS',
    SOLD_TO_ALL_EMAIL_FAILURE: 'POST_SOLD_TO_ALL_EMAIL_FAILURE',
    SOLD_TO_ALL_EMAIL_CLEAR_TOAST: 'SOLD_TO_ALL_EMAIL_CLEAR_TOAST',

    DOWNLOAD_INSEE_VOLUME_TEMPLATE_REQUEST: 'DOWNLOAD_INSEE_VOLUME_TEMPLATE_REQUEST',
    DOWNLOAD_INSEE_VOLUME_TEMPLATE_SUCCESS: 'DOWNLOAD_INSEE_VOLUME_TEMPLATE_SUCCESS',
    DOWNLOAD_INSEE_VOLUME_TEMPLATE_FAILURE: 'DOWNLOAD_INSEE_VOLUME_TEMPLATE_FAILURE',

    DOWNLOAD_CUSTOMER_GROUP_REQUEST: 'GET_DOWNLOAD_CUSTOMER_GROUP_REQUEST',
    DOWNLOAD_CUSTOMER_GROUP_SUCCESS: 'GET_DOWNLOAD_CUSTOMER_GROUP_SUCCESS',
    DOWNLOAD_CUSTOMER_GROUP_FAILURE: 'GET_DOWNLOAD_CUSTOMER_GROUP_FAILURE',

    UPDATE_TOTAL_INSEE_VOLUME_REQUEST: 'UPDATE_TOTAL_INSEE_VOLUME_REQUEST',
    UPDATE_TOTAL_INSEE_VOLUME_SUCCESS: 'UPDATE_TOTAL_INSEE_VOLUME_SUCCESS',
    UPDATE_TOTAL_INSEE_VOLUME_FAILURE: 'UPDATE_TOTAL_INSEE_VOLUME_FAILURE',
    UPDATE_TOTAL_INSEE_VOLUME_CLEAR_TOAST: 'UPDATE_TOTAL_INSEE_VOLUME_CLEAR_TOAST',

    UPLOAD_CUSTOMER_GROUP_CODE_REQUEST: 'UPLOAD_CUSTOMER_GROUP_CODE_REQUEST',
    UPLOAD_CUSTOMER_GROUP_CODE_SUCCESS: 'UPLOAD_CUSTOMER_GROUP_CODE_SUCCESS',
    UPLOAD_CUSTOMER_GROUP_CODE_FAILURE: 'UPLOAD_CUSTOMER_GROUP_CODE_FAILURE',
    UPLOAD_CUSTOMER_GROUP_CODE_CLEAR_TOAST: 'UPLOAD_CUSTOMER_GROUP_CODE_CLEAR_TOAST',

    SOLDTO_DROPDOWN_COUNTRY_REQUEST: 'SOLDTO_DROPDOWN_COUNTRY_REQUEST',
    SOLDTO_DROPDOWN_COUNTRY_SUCCESS: 'SOLDTO_DROPDOWN_COUNTRY_SUCCESS',
    SOLDTO_DROPDOWN_COUNTRY_FAILURE: 'SOLDTO_DROPDOWN_COUNTRY_FAILURE',
    SOLDTO_DROPDOWN_COUNTRY_CLEAR_STATE: 'SOLDTO_DROPDOWN_COUNTRY_CLEAR_STATE',

    SEND_SMS_FROM_SOLDTO_REQUEST: 'POST_SEND_SMS_FROM_SOLDTO_REQUEST',
    SEND_SMS_FROM_SOLDTO_SUCCESS: 'POST_SEND_SMS_FROM_SOLDTO_SUCCESS',
    SEND_SMS_FROM_SOLDTO_FAILURE: 'POST_SEND_SMS_FROM_SOLDTO_FAILURE',
    SEND_SMS_FROM_SOLDTO_CLEAR_TOAST: 'SEND_SMS_FROM_SOLDTO_CLEAR_TOAST',

    SOLDTO_PDPA_FOR_CUSTOMER_REQUEST: 'POST_SOLDTO_PDPA_FOR_CUSTOMER_REQUEST',
    SOLDTO_PDPA_FOR_CUSTOMER_SUCCESS: 'POST_SOLDTO_PDPA_FOR_CUSTOMER_SUCCESS',
    SOLDTO_PDPA_FOR_CUSTOMER_FAILURE: 'POST_SOLDTO_PDPA_FOR_CUSTOMER_FAILURE',


    UPDATE_ACTION_CATEGORY_REQUEST: 'PUT_UPDATE_ACTION_CATEGORY_REQUEST',
    UPDATE_ACTION_CATEGORY_SUCCESS: 'PUT_UPDATE_ACTION_CATEGORY_SUCCESS',
    UPDATE_ACTION_CATEGORY_FAILURE: 'PUT_UPDATE_ACTION_CATEGORY_FAILURE',

    DELETE_ACTION_CATEGORY_REQUEST: 'DELETE_ACTION_CATEGORY_REQUEST',
    DELETE_ACTION_CATEGORY_SUCCESS: 'DELETE_ACTION_CATEGORY_SUCCESS',
    DELETE_ACTION_CATEGORY_FAILURE: 'DELETE_ACTION_CATEGORY_FAILURE',


    UPDATE_ACTION_STATUS_REQUEST: 'PUT_UPDATE_ACTION_STATUS_REQUEST',
    UPDATE_ACTION_STATUS_SUCCESS: 'PUT_UPDATE_ACTION_STATUS_SUCCESS',
    UPDATE_ACTION_STATUS_FAILURE: 'PUT_UPDATE_ACTION_STATUS_FAILURE',

    DELETE_ACTION_STATUS_REQUEST: 'DELETE_ACTION_STATUS_REQUEST',
    DELETE_ACTION_STATUS_SUCCESS: 'DELETE_ACTION_STATUS_SUCCESS',
    DELETE_ACTION_STATUS_FAILURE: 'DELETE_ACTION_STATUS_FAILURE',

    UPDATE_AREA_TYPE_REQUEST: 'PUT_UPDATE_AREA_TYPE_REQUEST',
    UPDATE_AREA_TYPE_SUCCESS: 'PUT_UPDATE_AREA_TYPE_SUCCESS',
    UPDATE_AREA_TYPE_FAILURE: 'PUT_UPDATE_AREA_TYPE_FAILURE',

    DELETE_AREA_TYPE_REQUEST: 'DELETE_AREA_TYPE_REQUEST',
    DELETE_AREA_TYPE_SUCCESS: 'DELETE_AREA_TYPE_SUCCESS',
    DELETE_AREA_TYPE_FAILURE: 'DELETE_AREA_TYPE_FAILURE',

    UPDATE_CASE_ORIGIN_REQUEST: 'PUT_UPDATE_CASE_ORIGIN_REQUEST',
    UPDATE_CASE_ORIGIN_SUCCESS: 'PUT_UPDATE_CASE_ORIGIN_SUCCESS',
    UPDATE_CASE_ORIGIN_FAILURE: 'PUT_UPDATE_CASE_ORIGIN_FAILURE',
    UPDATE_CASE_ORIGIN_CLEAR: 'UPDATE_CASE_ORIGIN_CLEAR',

    DELETE_CASE_ORIGIN_REQUEST: 'DELETE_CASE_ORIGIN_REQUEST',
    DELETE_CASE_ORIGIN_SUCCESS: 'DELETE_CASE_ORIGIN_SUCCESS',
    DELETE_CASE_ORIGIN_FAILURE: 'DELETE_CASE_ORIGIN_FAILURE',


    UPDATE_COMPETITOR_PRODUCT_REQUEST: 'PUT_UPDATE_COMPETITOR_PRODUCT_REQUEST',
    UPDATE_COMPETITOR_PRODUCT_SUCCESS: 'PUT_UPDATE_COMPETITOR_PRODUCT_SUCCESS',
    UPDATE_COMPETITOR_PRODUCT_FAILURE: 'PUT_UPDATE_COMPETITOR_PRODUCT_FAILURE',

    DELETE_COMPETITOR_PRODUCT_REQUEST: 'DELETE_COMPETITOR_PRODUCT_REQUEST',
    DELETE_COMPETITOR_PRODUCT_SUCCESS: 'DELETE_COMPETITOR_PRODUCT_SUCCESS',
    DELETE_COMPETITOR_PRODUCT_FAILURE: 'DELETE_COMPETITOR_PRODUCT_FAILURE',

    UPDATE_CONSTRUCTION_PHASE_REQUEST: 'PUT_UPDATE_CONSTRUCTION_PHASE_REQUEST',
    UPDATE_CONSTRUCTION_PHASE_SUCCESS: 'PUT_UPDATE_CONSTRUCTION_PHASE_SUCCESS',
    UPDATE_CONSTRUCTION_PHASE_FAILURE: 'PUT_UPDATE_CONSTRUCTION_PHASE_FAILURE',

    DELETE_CONSTRUCTION_PHASE_REQUEST: 'DELETE_CONSTRUCTION_PHASE_REQUEST',
    DELETE_CONSTRUCTION_PHASE_SUCCESS: 'DELETE_CONSTRUCTION_PHASE_SUCCESS',
    DELETE_CONSTRUCTION_PHASE_FAILURE: 'DELETE_CONSTRUCTION_PHASE_FAILURE',

    UPDATE_DELIVERY_MODE_REQUEST: 'PUT_UPDATE_DELIVERY_MODE_REQUEST',
    UPDATE_DELIVERY_MODE_SUCCESS: 'PUT_UPDATE_DELIVERY_MODE_SUCCESS',
    UPDATE_DELIVERY_MODE_FAILURE: 'PUT_UPDATE_DELIVERY_MODE_FAILURE',

    DELETE_DELIVERY_MODE_REQUEST: 'DELETE_DELIVERY_MODE_REQUEST',
    DELETE_DELIVERY_MODE_SUCCESS: 'DELETE_DELIVERY_MODE_SUCCESS',
    DELETE_DELIVERY_MODE_FAILURE: 'DELETE_DELIVERY_MODE_FAILURE',

    SOLDTO_SELECT_DIVISION_REQUEST: 'GET_SOLDTO_SELECT_DIVISION_REQUEST',
    SOLDTO_SELECT_DIVISION_SUCCESS: 'GET_SOLDTO_SELECT_DIVISION_SUCCESS',
    SOLDTO_SELECT_DIVISION_FAILURE: 'GET_SOLDTO_SELECT_DIVISION_FAILURE',

    PREFFERED_TRUCK_DELIVERY_REQUEST: 'GET_PREFFERED_TRUCK_DELIVERY_REQUEST',
    PREFFERED_TRUCK_DELIVERY_SUCCESS: 'GET_PREFFERED_TRUCK_DELIVERY_SUCCESS',
    PREFFERED_TRUCK_DELIVERY_FAILURE: 'GET_PREFFERED_TRUCK_DELIVERY_FAILURE',

    
    ADD_PREFFERED_TRUCK_DELIVERY_REQUEST: 'POST_ADD_PREFFERED_TRUCK_DELIVERY_REQUEST',
    ADD_PREFFERED_TRUCK_DELIVERY_SUCCESS: 'POST_ADD_PREFFERED_TRUCK_DELIVERY_SUCCESS',
    ADD_PREFFERED_TRUCK_DELIVERY_FAILURE: 'POST_ADD_PREFFERED_TRUCK_DELIVERY_FAILURE',
    ADD_PREFFERED_TRUCK_DELIVERY_CLEAR_TOAST: 'ADD_PREFFERED_TRUCK_DELIVERY_CLEAR_TOAST',


    UPLOAD_PREFFERED_TRUCK_DELIVERY_REQUEST: 'UPLOAD_PREFFERED_TRUCK_DELIVERY_REQUEST',
    UPLOAD_PREFFERED_TRUCK_DELIVERY_SUCCESS: 'UPLOAD_PREFFERED_TRUCK_DELIVERY_SUCCESS',
    UPLOAD_PREFFERED_TRUCK_DELIVERY_FAILURE: 'UPLOAD_PREFFERED_TRUCK_DELIVERY_FAILURE',

    DELETE_PREFFERED_TRUCK_DELIVERY_REQUEST: 'DELETE_PREFFERED_TRUCK_DELIVERY_REQUEST',
    DELETE_PREFFERED_TRUCK_DELIVERY_SUCCESS: 'DELETE_PREFFERED_TRUCK_DELIVERY_SUCCESS',
    DELETE_PREFFERED_TRUCK_DELIVERY_FAILURE: 'DELETE_PREFFERED_TRUCK_DELIVERY_FAILURE',

    CHOOSE_TRANSPORTOR_ZONE_REQUEST: 'GET_CHOOSE_TRANSPORTOR_ZONE_REQUEST',
    CHOOSE_TRANSPORTOR_ZONE_SUCCESS: 'GET_CHOOSE_TRANSPORTOR_ZONE_SUCCESS',
    CHOOSE_TRANSPORTOR_ZONE_FAILURE: 'GET_CHOOSE_TRANSPORTOR_ZONE_FAILURE',

    ADD_CHOOSE_TRANSPORTOR_ZONE_REQUEST: 'ADD_CHOOSE_TRANSPORTOR_ZONE_REQUEST',
    ADD_CHOOSE_TRANSPORTOR_ZONE_SUCCESS: 'ADD_CHOOSE_TRANSPORTOR_ZONE_SUCCESS',
    ADD_CHOOSE_TRANSPORTOR_ZONE_FAILURE: 'ADD_CHOOSE_TRANSPORTOR_ZONE_FAILURE',
    ADD_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST: 'ADD_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST',

    UPLOAD_CHOOSE_TRANSPORTOR_ZONE_REQUEST: 'UPLOAD_CHOOSE_TRANSPORTOR_ZONE_REQUEST',
    UPLOAD_CHOOSE_TRANSPORTOR_ZONE_SUCCESS: 'UPLOAD_CHOOSE_TRANSPORTOR_ZONE_SUCCESS',
    UPLOAD_CHOOSE_TRANSPORTOR_ZONE_FAILURE: 'UPLOAD_CHOOSE_TRANSPORTOR_ZONE_FAILURE',
    UPLOAD_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST: 'UPLOAD_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST',

    DELETE_CHOOSE_TRANSPORTOR_ZONE_REQUEST: 'DELETE_CHOOSE_TRANSPORTOR_ZONE_REQUEST',
    DELETE_CHOOSE_TRANSPORTOR_ZONE_SUCCESS: 'DELETE_CHOOSE_TRANSPORTOR_ZONE_SUCCESS',
    DELETE_CHOOSE_TRANSPORTOR_ZONE_FAILURE: 'DELETE_CHOOSE_TRANSPORTOR_ZONE_FAILURE',
    DELETE_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST: 'DELETE_CHOOSE_TRANSPORTOR_ZONE_CLEAR_TOAST',

    UPDATE_PREFFERED_TRUCK_DELIVERY_REQUEST: 'UPDATE_PREFFERED_TRUCK_DELIVERY_REQUEST',
    UPDATE_PREFFERED_TRUCK_DELIVERY_SUCCESS: 'UPDATE_PREFFERED_TRUCK_DELIVERY_SUCCESS',
    UPDATE_PREFFERED_TRUCK_DELIVERY_FAILURE: 'UPDATE_PREFFERED_TRUCK_DELIVERY_FAILURE',
    UPDATE_PREFFERED_TRUCK_DELIVERY_TOAST: 'UPDATE_PREFFERED_TRUCK_DELIVERY_CLEAR_TOAST',

    UPDATE_CHOOSE_TRANSPORTOR_REQUEST: 'UPDATE_CHOOSE_TRANSPORTOR_REQUEST',
    UPDATE_CHOOSE_TRANSPORTOR_SUCCESS: 'UPDATE_CHOOSE_TRANSPORTOR_SUCCESS',
    UPDATE_CHOOSE_TRANSPORTOR_FAILURE: 'UPDATE_CHOOSE_TRANSPORTOR_FAILURE',
    UPDATE_CHOOSE_TRANSPORTOR_CLEAR_TOAST: 'UPDATE_CHOOSE_TRANSPORTOR_CLEAR_TOAST',



    UPLOAD_LOYALITY_CALC_RULES_REQUEST: 'UPLOAD_LOYALITY_CALC_RULES_REQUEST',
    UPLOAD_LOYALITY_CALC_RULES_SUCCESS: 'UPLOAD_LOYALITY_CALC_RULES_SUCCESS',
    UPLOAD_LOYALITY_CALC_RULES_FAILURE: 'UPLOAD_LOYALITY_CALC_RULES_FAILURE',
    UPLOAD_LOYALITY_CALC_RULES_CLEAR_TOAST: 'UPLOAD_LOYALITY_CALC_RULES_CLEAR_TOAST',

    UPLOAD_LOYALITY_CUTOFF_RULES_REQUEST: 'UPLOAD_LOYALITY_CUTOFF_RULES_REQUEST',
    UPLOAD_LOYALITY_CUTOFF_RULES_SUCCESS: 'UPLOAD_LOYALITY_CUTOFF_RULES_SUCCESS',
    UPLOAD_LOYALITY_CUTOFF_RULES_FAILURE: 'UPLOAD_LOYALITY_CUTOFF_RULES_FAILURE',
    UPLOAD_LOYALITY_CUTOFF_RULES_CLEAR_TOAST: 'UPLOAD_LOYALITY_CUTOFF_RULES_CLEAR_TOAST',

    UPLOAD_ADJUST_LOYALITY_ADMIN_REQUEST: 'UPLOAD_ADJUST_LOYALITY_ADMIN_REQUEST',
    UPLOAD_ADJUST_LOYALITY_ADMIN_SUCCESS: 'UPLOAD_ADJUST_LOYALITY_ADMIN_SUCCESS',
    UPLOAD_ADJUST_LOYALITY_ADMIN_FAILURE: 'UPLOAD_ADJUST_LOYALITY_ADMIN_FAILURE',
    UPLOAD_ADJUST_LOYALITY_ADMIN_CLEAR_TOAST: 'UPLOAD_ADJUST_LOYALITY_ADMIN_CLEAR_TOAST',


    GET_LOYALITY_CALC_RULES_REQUEST: 'GET_LOYALITY_CALC_RULES_REQUEST',
    GET_LOYALITY_CALC_RULES_SUCCESS: 'GET_LOYALITY_CALC_RULES_SUCCESS',
    GET_LOYALITY_CALC_RULES_FAILURE: 'GET_LOYALITY_CALC_RULES_FAILURE',

    GET_LOYALITY_CUTOFF_RULES_REQUEST: 'GET_LOYALITY_CUTOFF_RULES_REQUEST',
    GET_LOYALITY_CUTOFF_RULES_SUCCESS: 'GET_LOYALITY_CUTOFF_RULES_SUCCESS',
    GET_LOYALITY_CUTOFF_RULES_FAILURE: 'GET_LOYALITY_CUTOFF_RULES_FAILURE',

    GET_ADJUCT_LOYALITY_ADMIN_REQUEST: 'GET_ADJUCT_LOYALITY_ADMIN_REQUEST',
    GET_ADJUCT_LOYALITY_ADMIN_SUCCESS: 'GET_ADJUCT_LOYALITY_ADMIN_SUCCESS',
    GET_ADJUCT_LOYALITY_ADMIN_FAILURE: 'GET_ADJUCT_LOYALITY_ADMIN_FAILURE',

    DELETE_SPECIAL_PROJECT_DELIVERY_REQUEST: 'DELETE_SPECIAL_PROJECT_DELIVERY_REQUEST',
    DELETE_SPECIAL_PROJECT_DELIVERY_SUCCESS: 'DELETE_SPECIAL_PROJECT_DELIVERY_SUCCESS',
    DELETE_SPECIAL_PROJECT_DELIVERY_FAILURE: 'DELETE_SPECIAL_PROJECT_DELIVERY_FAILURE',
    DELETE_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST: 'DELETE_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST',

    UPLOAD_SPECIAL_PROJECT_DELIVERY_REQUEST: 'UPLOAD_SPECIAL_PROJECT_DELIVERY_REQUEST',
    UPLOAD_SPECIAL_PROJECT_DELIVERY_SUCCESS: 'UPLOAD_SPECIAL_PROJECT_DELIVERY_SUCCESS',
    UPLOAD_SPECIAL_PROJECT_DELIVERY_FAILURE: 'UPLOAD_SPECIAL_PROJECT_DELIVERY_FAILURE',
    UPLOAD_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST: 'UPLOAD_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST',

    UPDATE_SPECIAL_PROJECT_DELIVERY_REQUEST: 'UPDATE_SPECIAL_PROJECT_DELIVERY_REQUEST',
    UPDATE_SPECIAL_PROJECT_DELIVERY_SUCCESS: 'UPDATE_SPECIAL_PROJECT_DELIVERY_SUCCESS',
    UPDATE_SPECIAL_PROJECT_DELIVERY_FAILURE: 'UPDATE_SPECIAL_PROJECT_DELIVERY_FAILURE',
    UPDATE_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST: 'UPDATE_SPECIAL_PROJECT_DELIVERY_CLEAR_TOAST',


    DELETE_LOYALITY_CALC_RULES_REQUEST: 'DELETE_LOYALITY_CALC_RULES_REQUEST',
    DELETE_LOYALITY_CALC_RULES_SUCCESS: 'DELETE_LOYALITY_CALC_RULES_SUCCESS',
    DELETE_LOYALITY_CALC_RULES_FAILURE: 'DELETE_LOYALITY_CALC_RULES_FAILURE',
    DELETE_LOYALITY_CALC_RULES_CLEAR_TOAST: 'DELETE_LOYALITY_CALC_RULES_CLEAR_TOAST',

    DELETE_LOYALITY_CUTOFF_RULES_REQUEST: 'DELETE_LOYALITY_CUTOFF_RULES_REQUEST',
    DELETE_LOYALITY_CUTOFF_RULES_SUCCESS: 'DELETE_LOYALITY_CUTOFF_RULES_SUCCESS',
    DELETE_LOYALITY_CUTOFF_RULES_FAILURE: 'DELETE_LOYALITY_CUTOFF_RULES_FAILURE',
    DELETE_LOYALITY_CUTOFF_RULES_CLEAR_TOAST: 'DELETE_LOYALITY_CUTOFF_RULES_CLEAR_TOAST',

    DELETE_ADUJECT_LOYALITY_REQUEST: 'DELETE_ADUJECT_LOYALITY_REQUEST',
    DELETE_ADUJECT_LOYALITY_SUCCESS: 'DELETE_ADUJECT_LOYALITY_SUCCESS',
    DELETE_ADUJECT_LOYALITY_FAILURE: 'DELETE_ADUJECT_LOYALITY_FAILURE',
    DELETE_ADUJECT_LOYALITY_CLEAR_TOAST: 'DELETE_ADUJECT_LOYALITY_CLEAR_TOAST',

    SHIPTO_SELECT_PRODUCT_REQUEST: 'SHIPTO_SELECT_PRODUCT_REQUEST',
    SHIPTO_SELECT_PRODUCT_SUCCESS: 'SHIPTO_SELECT_PRODUCT_SUCCESS',
    SHIPTO_SELECT_PRODUCT_FAILURE: 'SHIPTO_SELECT_PRODUCT_FAILURE',

    PRODUCT_ASSIGN_LIST_SEARCH_REQUEST: 'GET_PRODUCT_ASSIGN_LIST_SEARCH_REQUEST',
    PRODUCT_ASSIGN_LIST_SEARCH_SUCCESS: 'GET_PRODUCT_ASSIGN_LIST_SEARCH_SUCCESS',
    PRODUCT_ASSIGN_LIST_SEARCH_FAILURE: 'GET_PRODUCT_ASSIGN_LIST_SEARCH_FAILURE',

    DELETE_CUSTOMER_USERMANAGMENT_REQUEST: 'DELETE_CUSTOMER_USERMANAGMENT_REQUEST',
    DELETE_CUSTOMER_USERMANAGMENT_SUCCESS: 'DELETE_CUSTOMER_USERMANAGMENT_SUCCESS',
    DELETE_CUSTOMER_USERMANAGMENT_FAILURE: 'DELETE_CUSTOMER_USERMANAGMENT_FAILURE',
    DELETE_CUSTOMER_USERMANAGMENT_CLEAR_STATE: 'DELETE_CUSTOMER_USERMANAGMENT_CLEAR_STATE',

    UPDATE_CUSTOMER_USERMANAGMENT_REQUEST: 'UPDATE_CUSTOMER_USERMANAGMENT_REQUEST',
    UPDATE_CUSTOMER_USERMANAGMENT_SUCCESS: 'UPDATE_CUSTOMER_USERMANAGMENT_SUCCESS',
    UPDATE_CUSTOMER_USERMANAGMENT_FAILURE: 'UPDATE_CUSTOMER_USERMANAGMENT_FAILURE',
    UPDATE_CUSTOMER_USERMANAGMENT_CLEAR_STATE: 'UPDATE_CUSTOMER_USERMANAGMENT_CLEAR_STATE',

    CUSTOMER_USERID_REQUEST: 'CUSTOMER_USERID_REQUEST',
    CUSTOMER_USERID_SUCCESS: 'CUSTOMER_USERID_SUCCESS',
    CUSTOMER_USERID_FAILURE: 'CUSTOMER_USERID_FAILURE',

    STATUS_USERMANAGMENT_TYPE_REQUEST: 'STATUS_USERMANAGMENT_TYPE_REQUEST',
    STATUS_USERMANAGMENT_TYPE_SUCCESS: 'STATUS_USERMANAGMENT_TYPE_SUCCESS',
    STATUS_USERMANAGMENT_TYPE_FAILURE: 'STATUS_USERMANAGMENT_TYPE_FAILURE',
    STATUS_USERMANAGMENT_TYPE_CLEAR_STATE: 'STATUS_USERMANAGMENT_TYPE_CLEAR_STATE',

    RETAILER_MAKE_INSEE_PLUS_REQUEST: 'RETAILER_MAKE_INSEE_PLUS_REQUEST',
    RETAILER_MAKE_INSEE_PLUS_SUCCESS: 'RETAILER_MAKE_INSEE_PLUS_SUCCESS',
    RETAILER_MAKE_INSEE_PLUS_FAILURE: 'RETAILER_MAKE_INSEE_PLUS_FAILURE',
    RETAILER_MAKE_INSEE_PLUS_CLEAR_TOAST: 'RETAILER_MAKE_INSEE_PLUS_CLEAR_TOAST',
  
    RETAILER_CONTACT_LIST_REQUEST: 'GET_RETAILER_CONTACT_LIST_REQUEST',
    RETAILER_CONTACT_LIST_SUCCESS: 'GET_RETAILER_CONTACT_LIST_SUCCESS',
    RETAILER_CONTACT_LIST_FAILURE: 'GET_RETAILER_CONTACT_LIST_FAILURE',

    UPLOAD__RETAILER_CONTACT_REQUEST: 'UPLOAD__RETAILER_CONTACT_REQUEST',
    UPLOAD__RETAILER_CONTACT_SUCCESS: 'UPLOAD__RETAILER_CONTACT_SUCCESS',
    UPLOAD__RETAILER_CONTACT_FAILURE: 'UPLOAD__RETAILER_CONTACT_FAILURE',
    UPLOAD__RETAILER_CONTACT_CLEAR_TOAST: 'UPLOAD__RETAILER_CONTACT_CLEAR_TOAST',

    RETAILER_USERID_REQUEST: 'GET_RETAILER_USERID_REQUEST',
    RETAILER_USERID_SUCCESS: 'GET_RETAILER_USERID_SUCCESS',
    RETAILER_USERID_FAILURE: 'GET_RETAILER_USERID_FAILURE',

    LOYALTY_COMPANY_TYPE_LIST_REQUEST: 'GET_LOYALTY_COMPANY_TYPE_LIST_REQUEST',
    LOYALTY_COMPANY_TYPE_LIST_SUCCESS: 'GET_LOYALTY_COMPANY_TYPE_LIST_SUCCESS',
    LOYALTY_COMPANY_TYPE_LIST_FAILURE: 'GET_LOYALTY_COMPANY_TYPE_LIST_FAILURE',

    UPDATE_LOYALTY_POINT_FORM_REQUEST: 'UPDATE_LOYALTY_POINT_FORM_REQUEST',
    UPDATE_LOYALTY_POINT_FORM_SUCCESS: 'UPDATE_LOYALTY_POINT_FORM_SUCCESS',
    UPDATE_LOYALTY_POINT_FORM_FAILURE: 'UPDATE_LOYALTY_POINT_FORM_FAILURE',
    UPDATE_LOYALTY_POINT_FORM_CLEAR_TOAST: 'UPDATE_LOYALTY_POINT_FORM_CLEAR_TOAST',

    UPDATE_LOYALTY_CUT_OFF_REQUEST: 'UPDATE_LOYALTY_CUT_OFF_REQUEST',
    UPDATE_LOYALTY_CUT_OFF_SUCCESS: 'UPDATE_LOYALTY_CUT_OFF_SUCCESS',
    UPDATE_LOYALTY_CUT_OFF_FAILURE: 'UPDATE_LOYALTY_CUT_OFF_FAILURE',
    UPDATE_LOYALTY_CUT_OFF_CLEAR_TOAST: 'UPDATE_LOYALTY_CUT_OFF_CLEAR_TOAST',

    LOYALTY_CATEGORY_MASTER_REQUEST: 'GET_LOYALTY_CATEGORY_MASTER_REQUEST',
    LOYALTY_CATEGORY_MASTER_SUCCESS: 'GET_LOYALTY_CATEGORY_MASTER_SUCCESS',
    LOYALTY_CATEGORY_MASTER_FAILURE: 'GET_LOYALTY_CATEGORY_MASTER_FAILURE',

    GET_REDAM_LIST_REQUEST: 'GET_REDAM_LIST_REQUEST',
    GET_REDAM_LIST_SUCCESS: 'GET_REDAM_LIST_SUCCESS',
    GET_REDAM_LIST_FAILURE: 'GET_REDAM_LIST_FAILURE',

    GET_EARN_POINT_LIST_REQUEST: 'GET_EARN_POINT_LIST_REQUEST',
    GET_EARN_POINT_LIST_SUCCESS: 'GET_EARN_POINT_LIST_SUCCESS',
    GET_EARN_POINT_LIST_FAILURE: 'GET_EARN_POINT_LIST_FAILURE',

    MATERIAL_GROUP_LIST_REQUEST: 'GET_MATERIAL_GROUP_LIST_REQUEST',
    MATERIAL_GROUP_LIST_SUCCESS: 'GET_MATERIAL_GROUP_LIST_SUCCESS',
    MATERIAL_GROUP_LIST_FAILURE: 'GET_MATERIAL_GROUP_LIST_FAILURE',

    DEALER_CUSTOMER_NAME_REQUEST: 'GET_DEALER_CUSTOMER_NAME_REQUEST',
    DEALER_CUSTOMER_NAME_SUCCESS: 'GET_DEALER_CUSTOMER_NAME_SUCCESS',
    DEALER_CUSTOMER_NAME_FAILURE: 'GET_DEALER_CUSTOMER_NAME_FAILURE',

    UPLOAD_CONTACT_VNLK_REQUEST: 'UPLOAD_CONTACT_VNLK_REQUEST',
    UPLOAD_CONTACT_VNLK_SUCCESS: 'UPLOAD_CONTACT_VNLK_SUCCESS',
    UPLOAD_CONTACT_VNLK_FAILURE: 'UPLOAD_CONTACT_VNLK_FAILURE',
    UPLOAD_CONTACT_VNLK_CLEAR_TOAST: 'UPLOAD_CONTACT_VNLK_CLEAR_TOAST',

    DOWNLOAD_VNLK_URL_REQUEST: 'GET_DOWNLOAD_VNLK_URL_REQUEST',
    DOWNLOAD_VNLK_URL_SUCCESS: 'GET_DOWNLOAD_VNLK_URL_SUCCESS',
    DOWNLOAD_VNLK_URL_FAILURE: 'GET_DOWNLOAD_VNLK_URL_FAILURE',

    DELETE_PRODUCT_IMAGE_REQUEST: 'DELETE_PRODUCT_IMAGE_REQUEST',
    DELETE_PRODUCT_IMAGE_SUCCESS: 'DELETE_PRODUCT_IMAGE_SUCCESS',
    DELETE_PRODUCT_IMAGE_FAILURE: 'DELETE_PRODUCT_IMAGE_FAILURE',
    DELETE_PRODUCT_IMAGE_CLEAR_STATE: 'DELETE_PRODUCT_IMAGE_CLEAR_STATE',

    HOLIDAY_MASTER_LIST_REQUEST: 'GET_HOLIDAY_MASTER_LIST_REQUEST',
    HOLIDAY_MASTER_LIST_SUCCESS: 'GET_HOLIDAY_MASTER_LIST_SUCCESS',
    HOLIDAY_MASTER_LIST_FAILURE: 'GET_HOLIDAY_MASTER_LIST_FAILURE',

    ADD_HOLIDAY_MASTER_REQUEST: 'POST_ADD_HOLIDAY_MASTER_REQUEST',
    ADD_HOLIDAY_MASTER_SUCCESS: 'POST_ADD_HOLIDAY_MASTER_SUCCESS',
    ADD_HOLIDAY_MASTER_FAILURE: 'POST_ADD_HOLIDAY_MASTER_FAILURE',
    ADD_HOLIDAY_MASTER_CLEAR_STATE: 'ADD_HOLIDAY_MASTER_CLEAR_STATE',

    UPDATE_HOLIDAY_MASTER_REQUEST: 'PUT_UPDATE_HOLIDAY_MASTER_REQUEST',
    UPDATE_HOLIDAY_MASTER_SUCCESS: 'PUT_UPDATE_HOLIDAY_MASTER_SUCCESS',
    UPDATE_HOLIDAY_MASTER_FAILURE: 'PUT_UPDATE_HOLIDAY_MASTER_FAILURE',
    UPDATE_HOLIDAY_MASTER_CLEAR_STATE: 'PUT_UPDATE_HOLIDAY_MASTER_CLEAR_STATE',

    DELETE_HOLIDAY_MASTER_REQUEST: 'DELETE_HOLIDAY_MASTER_REQUEST',
    DELETE_HOLIDAY_MASTER_SUCCESS: 'DELETE_HOLIDAY_MASTER_SUCCESS',
    DELETE_HOLIDAY_MASTER_FAILURE: 'DELETE_HOLIDAY_MASTER_FAILURE',
    DELETE_HOLIDAY_MASTER_CLEAR_STATE: 'DELETE_HOLIDAY_MASTER_CLEAR_STATE',

    UPLOAD_HOLIDAY_MASTER_REQUEST: 'UPLOAD_HOLIDAY_MASTER_REQUEST',
    UPLOAD_HOLIDAY_MASTER_SUCCESS: 'UPLOAD_HOLIDAY_MASTER_SUCCESS',
    UPLOAD_HOLIDAY_MASTER_FAILURE: 'UPLOAD_HOLIDAY_MASTER_FAILURE',
    UPLOAD_HOLIDAY_MASTER_CLEAR_STATE: 'UPLOAD_HOLIDAY_MASTER_CLEAR_STATE',

    WEEKEND_HOLIDAY_LIST_REQUEST: 'GET_WEEKEND_HOLIDAY_LIST_REQUEST',
    WEEKEND_HOLIDAY_LIST_SUCCESS: 'GET_WEEKEND_HOLIDAY_LIST_SUCCESS',
    WEEKEND_HOLIDAY_LIST_FAILURE: 'GET_WEEKEND_HOLIDAY_LIST_FAILURE',

    UPLOAD_WEEKEND_MASTER_REQUEST: 'UPLOAD_WEEKEND_MASTER_REQUEST',
    UPLOAD_WEEKEND_MASTER_SUCCESS: 'UPLOAD_WEEKEND_MASTER_SUCCESS',
    UPLOAD_WEEKEND_MASTER_FAILURE: 'UPLOAD_WEEKEND_MASTER_FAILURE',
    UPLOAD_WEEKEND_MASTER_CLEAR_STATE: 'UPLOAD_WEEKEND_MASTER_CLEAR_STATE',

    DELETE_SUB_DEALER_SOLDTO_REQUEST: 'DELETE_SUB_DEALER_SOLDTO_REQUEST',
    DELETE_SUB_DEALER_SOLDTO_SUCCESS: 'DELETE_SUB_DEALER_SOLDTO_SUCCESS',
    DELETE_SUB_DEALER_SOLDTO_FAILURE: 'DELETE_SUB_DEALER_SOLDTO_FAILURE',
    DELETE_SUB_DEALER_SOLDTO_CLEAR_STATE: 'DELETE_SUB_DEALER_SOLDTO_CLEAR_STATE',

    UPDATE_SUB_DEALER_SOLDTO_REQUEST: 'UPDATE_SUB_DEALER_SOLDTO_REQUEST',
    UPDATE_SUB_DEALER_SOLDTO_SUCCESS: 'UPDATE_SUB_DEALER_SOLDTO_SUCCESS',
    UPDATE_SUB_DEALER_SOLDTO_FAILURE: 'UPDATE_SUB_DEALER_SOLDTO_FAILURE',
    UPDATE_SUB_DEALER_SOLDTO_CLEAR_STATE: 'UPDATE_SUB_DEALER_SOLDTO_CLEAR_STATE',

    VOLUME_ALLOCATION_LIST_REQUEST: 'VOLUME_ALLOCATION_LIST_REQUEST',
    VOLUME_ALLOCATION_LIST_SUCCESS: 'VOLUME_ALLOCATION_LIST_SUCCESS',
    VOLUME_ALLOCATION_LIST_FAILURE: 'VOLUME_ALLOCATION_LIST_FAILURE',

    DELETE_VOLUME_ALLOCATION_REQUEST: 'DELETE_VOLUME_ALLOCATION_REQUEST',
    DELETE_VOLUME_ALLOCATION_SUCCESS: 'DELETE_VOLUME_ALLOCATION_SUCCESS',
    DELETE_VOLUME_ALLOCATION_FAILURE: 'DELETE_VOLUME_ALLOCATION_FAILURE',
    DELETE_VOLUME_ALLOCATION_CLEAR_STATE: 'DELETE_VOLUME_ALLOCATION_CLEAR_STATE',

    CREATE_RETAILER_SUBDEALER_REQUEST: 'CREATE_RETAILER_SUBDEALER_REQUEST',
    CREATE_RETAILER_SUBDEALER_SUCCESS: 'CREATE_RETAILER_SUBDEALER_SUCCESS',
    CREATE_RETAILER_SUBDEALER_FAILURE: 'CREATE_RETAILER_SUBDEALER_FAILURE',
    CREATE_RETAILER_SUBDEALER_CLEAR_TOAST:'CREATE_RETAILER_SUBDEALER_CLEAR_TOAST',

    SALES_REP_LIST_REQUEST: 'GET_SALES_REP_LIST_REQUEST',
    SALES_REP_LIST_SUCCESS: 'GET_SALES_REP_LIST_SUCCESS',
    SALES_REP_LIST_FAILURE: 'GET_SALES_REP_LIST_FAILURE',

    SALES_DISTRICT_LIST_REQUEST: 'GET_SALES_DISTRICT_LIST_REQUEST',
    SALES_DISTRICT_LIST_SUCCESS: 'GET_SALES_DISTRICT_LIST_SUCCESS',
    SALES_DISTRICT_LIST_FAILURE: 'GET_SALES_DISTRICT_LIST_FAILURE',

    UPDATE_VOLUME_CUT_OFF_REQUEST: 'UPDATE_VOLUME_CUT_OFF_REQUEST',
    UPDATE_VOLUME_CUT_OFF_SUCCESS: 'UPDATE_VOLUME_CUT_OFF_SUCCESS',
    UPDATE_VOLUME_CUT_OFF_FAILURE: 'UPDATE_VOLUME_CUT_OFF_FAILURE',
    UPDATE_VOLUME_CUT_OFF_CLEAR_TOAST: 'UPDATE_VOLUME_CUT_OFF_CLEAR_STATE',

    RETAILER_AUTO_FIELD_REQUEST: 'GET_RETAILER_AUTO_FIELD_REQUEST',
    RETAILER_AUTO_FIELD_SUCCESS: 'GET_RETAILER_AUTO_FIELD_SUCCESS',
    RETAILER_AUTO_FIELD_FAILURE: 'GET_RETAILER_AUTO_FIELD_FAILURE',

    RETAILER_ALL_CONTACT_LIST_REQUEST: 'GET_RETAILER_ALL_CONTACT_LIST_REQUEST',
    RETAILER_ALL_CONTACT_LIST_SUCCESS: 'GET_RETAILER_ALL_CONTACT_LIST_SUCCESS',
    RETAILER_ALL_CONTACT_LIST_FAILURE: 'GET_RETAILER_ALL_CONTACT_LIST_FAILURE',

    RETAILER_ACCOUNT_FORM_DATA_REQUEST: "POST_RETAILER_ACCOUNT_FORM_DATA_REQUEST",
    RETAILER_ACCOUNT_FORM_DATA_SUCCESS: "POST_RETAILER_ACCOUNT_FORM_DATA_SUCCESS",
    RETAILER_ACCOUNT_FORM_DATA_FAILURE: "POST_RETAILER_ACCOUNT_FORM_DATA_FAILURE",
    RETAILER_ACCOUNT_FORM_DATA_CLEAR: 'RETAILER_ACCOUNT_FORM_DATA_CLEAR',

    UPDATE_RETAILER_SOLDTO_REQUEST: 'UPDATE_RETAILER_SOLDTO_REQUEST',
    UPDATE_RETAILER_SOLDTO_SUCCESS: 'UPDATE_RETAILER_SOLDTO_SUCCESS',
    UPDATE_RETAILER_SOLDTO_FAILURE: 'UPDATE_RETAILER_SOLDTO_FAILURE',
    UPDATE_RETAILER_SOLDTO_CLEAR_TOAST: 'UPDATE_RETAILER_SOLDTO_CLEAR_STATE',


    DELETE_RETAILER_SOLDTO_REQUEST: 'DELETE_RETAILER_SOLDTO_REQUEST',
    DELETE_RETAILER_SOLDTO_SUCCESS: 'DELETE_RETAILER_SOLDTO_SUCCESS',
    DELETE_RETAILER_SOLDTO_FAILURE: 'DELETE_RETAILER_SOLDTO_FAILURE',
    DELETE_RETAILER_SOLDTO_CLEAR_TOAST: 'DELETE_RETAILER_SOLDTO_CLEAR_TOAST',

    UPDATE_RETAILER_ACCOUNT_LIST_REQUEST: 'UPDATE_RETAILER_ACCOUNT_LIST_REQUEST',
    UPDATE_RETAILER_ACCOUNT_LIST_SUCCESS: 'UPDATE_RETAILER_ACCOUNT_LIST_SUCCESS',
    UPDATE_RETAILER_ACCOUNT_LIST_FAILURE: 'UPDATE_RETAILER_ACCOUNT_LIST_FAILURE',
    UPDATE_RETAILER_ACCOUNT_LIST_CLEAR: 'UPDATE_RETAILER_ACCOUNT_LIST_CLEAR',

    DELETE_RETAILER_CONTACT_LIST_REQUEST: 'DELETE_RETAILER_CONTACT_LIST_REQUEST',
    DELETE_RETAILER_CONTACT_LIST_SUCCESS: 'DELETE_RETAILER_CONTACT_LIST_SUCCESS',
    DELETE_RETAILER_CONTACT_LIST_FAILURE: 'DELETE_RETAILER_CONTACT_LIST_FAILURE',
    DELETE_RETAILER_CONTACT_LIST_CLEAR_TOAST: 'DELETE_RETAILER_CONTACT_LIST_CLEAR_TOAST',

    AUTOFILL_RETAILER_CONTACT_REQUEST: 'GET_AUTOFILL_RETAILER_CONTACT_REQUEST',
    AUTOFILL_RETAILER_CONTACT_SUCCESS: 'GET_AUTOFILL_RETAILER_CONTACT_SUCCESS',
    AUTOFILL_RETAILER_CONTACT_FAILURE: 'GET_AUTOFILL_RETAILER_CONTACT_FAILURE',

    EXISTING_CUSTOMER_LIST_REQUEST: 'GET_EXISTING_CUSTOMER_LIST_REQUEST',
    EXISTING_CUSTOMER_LIST_SUCCESS: 'GET_EXISTING_CUSTOMER_LIST_SUCCESS',
    EXISTING_CUSTOMER_LIST_FAILURE: 'GET_EXISTING_CUSTOMER_LIST_FAILURE',

    UPLOAD_EXISTING_CUSTOMER_REQUEST: 'UPLOAD_EXISTING_CUSTOMER_REQUEST',
    UPLOAD_EXISTING_CUSTOMER_SUCCESS: 'UPLOAD_EXISTING_CUSTOMER_SUCCESS',
    UPLOAD_EXISTING_CUSTOMER_FAILURE: 'UPLOAD_EXISTING_CUSTOMER_FAILURE',
    UPLOAD_EXISTING_CUSTOMER_CLEAR_STATE: 'UPLOAD_EXISTING_CUSTOMER_CLEAR_STATE',

    DELETE_EXISTING_CUSTOMER_REQUEST: 'DELETE_EXISTING_CUSTOMER_REQUEST',
    DELETE_EXISTING_CUSTOMER_SUCCESS: 'DELETE_EXISTING_CUSTOMER_SUCCESS',
    DELETE_EXISTING_CUSTOMER_FAILURE: 'DELETE_EXISTING_CUSTOMER_FAILURE',
    DELETE_EXISTING_CUSTOMER_CLEAR_TOAST: 'DELETE_EXISTING_CUSTOMER_CLEAR_TOAST',

    UPDATE_EXISTING_CUSTOMER_REQUEST: 'UPDATE_EXISTING_CUSTOMER_REQUEST',
    UPDATE_EXISTING_CUSTOMER_SUCCESS: 'UPDATE_EXISTING_CUSTOMER_SUCCESS',
    UPDATE_EXISTING_CUSTOMER_FAILURE: 'UPDATE_EXISTING_CUSTOMER_FAILURE',
    UPDATE_EXISTING_CUSTOMER_CLEAR_TOAST: 'UPDATE_EXISTING_CUSTOMER_CLEAR_TOAST',

    NON_CUSTOMER_INACTIVE_REQUEST: 'GET_NON_CUSTOMER_INACTIVE_REQUEST',
    NON_CUSTOMER_INACTIVE_SUCCESS: 'GET_NON_CUSTOMER_INACTIVE_SUCCESS',
    NON_CUSTOMER_INACTIVE_FAILURE: 'GET_NON_CUSTOMER_INACTIVE_FAILURE',

    UPLOAD_CUSTOMER_INACTIVE_REQUEST: 'UPLOAD_CUSTOMER_INACTIVE_REQUEST',
    UPLOAD_CUSTOMER_INACTIVE_SUCCESS: 'UPLOAD_CUSTOMER_INACTIVE_SUCCESS',
    UPLOAD_CUSTOMER_INACTIVE_FAILURE: 'UPLOAD_CUSTOMER_INACTIVE_FAILURE',
    UPLOAD_CUSTOMER_INACTIVE_CLEAR_STATE: 'UPLOAD_CUSTOMER_INACTIVE_CLEAR_STATE',

    DELETE_CUSTOMER_INACTIVE_REQUEST: 'DELETE_CUSTOMER_INACTIVE_REQUEST',
    DELETE_CUSTOMER_INACTIVE_SUCCESS: 'DELETE_CUSTOMER_INACTIVE_SUCCESS',
    DELETE_CUSTOMER_INACTIVE_FAILURE: 'DELETE_CUSTOMER_INACTIVE_FAILURE',
    DELETE_CUSTOMER_INACTIVE_CLEAR_TOAST: 'DELETE_CUSTOMER_INACTIVE_CLEAR_TOAST',

    UPDATE_CUSTOMER_INACTIVE_REQUEST: 'UPDATE_CUSTOMER_INACTIVE_REQUEST',
    UPDATE_CUSTOMER_INACTIVE_SUCCESS: 'UPDATE_CUSTOMER_INACTIVE_SUCCESS',
    UPDATE_CUSTOMER_INACTIVE_FAILURE: 'UPDATE_CUSTOMER_INACTIVE_FAILURE',
    UPDATE_CUSTOMER_INACTIVE_CLEAR_TOAST: 'UPDATE_CUSTOMER_INACTIVE_CLEAR_TOAST',

    ACTIVITY_TARGET_LIST_REQUEST: 'GET_ACTIVITY_TARGET_LIST_REQUEST',
    ACTIVITY_TARGET_LIST_SUCCESS: 'GET_ACTIVITY_TARGET_LIST_SUCCESS',
    ACTIVITY_TARGET_LIST_FAILURE: 'GET_ACTIVITY_TARGET_LIST_FAILURE',

    
    UPLOAD_ACTIVITY_TARGET_REQUEST: 'UPLOAD_ACTIVITY_TARGET_REQUEST',
    UPLOAD_ACTIVITY_TARGET_SUCCESS: 'UPLOAD_ACTIVITY_TARGET_SUCCESS',
    UPLOAD_ACTIVITY_TARGET_FAILURE: 'UPLOAD_ACTIVITY_TARGET_FAILURE',
    UPLOAD_ACTIVITY_TARGET_CLEAR_STATE: 'UPLOAD_ACTIVITY_TARGET_CLEAR_STATE',

    UPDATE_ACTIVITY_TARGET_REQUEST: 'UPDATE_ACTIVITY_TARGET_REQUEST',
    UPDATE_ACTIVITY_TARGET_SUCCESS: 'UPDATE_ACTIVITY_TARGET_SUCCESS',
    UPDATE_ACTIVITY_TARGET_FAILURE: 'UPDATE_ACTIVITY_TARGET_FAILURE',
    UPDATE_ACTIVITY_TARGET_CLEAR_TOAST: 'UPDATE_ACTIVITY_TARGET_CLEAR_TOAST',

    BEAT_LIST_REQUEST: 'GET_BEAT_LIST_REQUEST',
    BEAT_LIST_SUCCESS: 'GET_BEAT_LIST_SUCCESS',
    BEAT_LIST_FAILURE: 'GET_BEAT_LIST_FAILURE',

    UPLOAD_BEAT_LIST_REQUEST: 'UPLOAD_BEAT_LIST_REQUEST',
    UPLOAD_BEAT_LIST_SUCCESS: 'UPLOAD_BEAT_LIST_SUCCESS',
    UPLOAD_BEAT_LIST_FAILURE: 'UPLOAD_BEAT_LIST_FAILURE',
    UPLOAD_BEAT_LIST_CLEAR_STATE: 'UPLOAD_BEAT_LIST_CLEAR_STATE',

    RELATION_WITH_CUSTOMER_REQUEST: 'GET_RELATION_WITH_CUSTOMER_REQUEST',
    RELATION_WITH_CUSTOMER_SUCCESS: 'GET_RELATION_WITH_CUSTOMER_SUCCESS',
    RELATION_WITH_CUSTOMER_FAILURE: 'GET_RELATION_WITH_CUSTOMER_FAILURE',

    UPLOAD_RELATION_CUSTOMER_REQUEST: 'UPLOAD_RELATION_CUSTOMER_REQUEST',
    UPLOAD_RELATION_CUSTOMER_SUCCESS: 'UPLOAD_RELATION_CUSTOMER_SUCCESS',
    UPLOAD_RELATION_CUSTOMER_FAILURE: 'UPLOAD_RELATION_CUSTOMER_FAILURE',
    UPLOAD_RELATION_CUSTOMER_CLEAR_STATE: 'UPLOAD_RELATION_CUSTOMER_CLEAR_STATE',

    DELETE_ACTIVITY_TARGET_REQUEST: 'DELETE_ACTIVITY_TARGET_REQUEST',
    DELETE_ACTIVITY_TARGET_SUCCESS: 'DELETE_ACTIVITY_TARGET_SUCCESS',
    DELETE_ACTIVITY_TARGET_FAILURE: 'DELETE_ACTIVITY_TARGET_FAILURE',
    DELETE_ACTIVITY_TARGET_CLEAR_TOAST: 'DELETE_ACTIVITY_TARGET_CLEAR_TOAST',

    DELETE_BEAT_MASTER_REQUEST: 'DELETE_BEAT_MASTER_REQUEST',
    DELETE_BEAT_MASTER_SUCCESS: 'DELETE_BEAT_MASTER_SUCCESS',
    DELETE_BEAT_MASTER_FAILURE: 'DELETE_BEAT_MASTER_FAILURE',
    DELETE_BEAT_MASTER_CLEAR_TOAST: 'DELETE_BEAT_MASTER_CLEAR_TOAST',

    DELETE_CUSTOMER_RELATION_REQUEST: 'DELETE_CUSTOMER_RELATION_REQUEST',
    DELETE_CUSTOMER_RELATION_SUCCESS: 'DELETE_CUSTOMER_RELATION_SUCCESS',
    DELETE_CUSTOMER_RELATION_FAILURE: 'DELETE_CUSTOMER_RELATION_FAILURE',
    DELETE_CUSTOMER_RELATION_CLEAR_TOAST: 'DELETE_CUSTOMER_RELATION_CLEAR_TOAST',

    DOWNLOAD_EXISTING_CUSTOMER_REQUEST: 'DOWNLOAD_EXISTING_CUSTOMER_REQUEST',
    DOWNLOAD_EXISTING_CUSTOMER_SUCCESS: 'DOWNLOAD_EXISTING_CUSTOMER_SUCCESS',
    DOWNLOAD_EXISTING_CUSTOMER_FAILURE: 'DOWNLOAD_EXISTING_CUSTOMER_FAILURE',

    DOWNLOAD_INACTIVE_CUSTOMER_REQUEST: 'DOWNLOAD_INACTIVE_CUSTOMER_REQUEST',
    DOWNLOAD_INACTIVE_CUSTOMER_SUCCESS: 'DOWNLOAD_INACTIVE_CUSTOMER_SUCCESS',
    DOWNLOAD_INACTIVE_CUSTOMER_FAILURE: 'DOWNLOAD_INACTIVE_CUSTOMER_FAILURE',

    DOWNLOAD_ACTIVITY_TARGET_REQUEST: 'DOWNLOAD_ACTIVITY_TARGET_REQUEST',
    DOWNLOAD_ACTIVITY_TARGET_SUCCESS: 'DOWNLOAD_ACTIVITY_TARGET_SUCCESS',
    DOWNLOAD_ACTIVITY_TARGET_FAILURE: 'DOWNLOAD_ACTIVITY_TARGET_FAILURE',


    DOWNLOAD_BEAT_MASTER_REQUEST: 'DOWNLOAD_BEAT_MASTER_REQUEST',
    DOWNLOAD_BEAT_MASTER_SUCCESS: 'DOWNLOAD_BEAT_MASTER_SUCCESS',
    DOWNLOAD_BEAT_MASTER_FAILURE: 'DOWNLOAD_BEAT_MASTER_FAILURE',


    BEAT_MASTER_SEARCH_REQUEST: 'BEAT_MASTER_SEARCH_REQUEST',
    BEAT_MASTER_SEARCH_SUCCESS: 'BEAT_MASTER_SEARCH_SUCCESS',
    BEAT_MASTER_SEARCH_FAILURE: 'BEAT_MASTER_SEARCH_FAILURE',

    UPDATE_BEAT_MASTER_REQUEST: 'UPDATE_BEAT_MASTER_REQUEST',
    UPDATE_BEAT_MASTER_SUCCESS: 'UPDATE_BEAT_MASTER_SUCCESS',
    UPDATE_BEAT_MASTER_FAILURE: 'UPDATE_BEAT_MASTER_FAILURE',
    UPDATE_BEAT_MASTER_CLEAR_TOAST: 'UPDATE_BEAT_MASTER_CLEAR_TOAST',

    DOWNLOAD_RELATION_CUSTOMER_REQUEST: 'DOWNLOAD_RELATION_CUSTOMER_REQUEST',
    DOWNLOAD_RELATION_CUSTOMER_SUCCESS: 'DOWNLOAD_RELATION_CUSTOMER_SUCCESS',
    DOWNLOAD_RELATION_CUSTOMER_FAILURE: 'DOWNLOAD_RELATION_CUSTOMER_FAILURE',

    UPDATE_RELATION_CUSTOMER_REQUEST: 'UPDATE_RELATION_CUSTOMER_REQUEST',
    UPDATE_RELATION_CUSTOMER_SUCCESS: 'UPDATE_RELATION_CUSTOMER_SUCCESS',
    UPDATE_RELATION_CUSTOMER_FAILURE: 'UPDATE_RELATION_CUSTOMER_FAILURE',
    UPDATE_RELATION_CUSTOMER_CLEAR_TOAST: 'UPDATE_RELATION_CUSTOMER_CLEAR_TOAST',

    RELATION_SEARCH_REQUEST: 'RELATION_SEARCH_REQUEST',
    RELATION_SEARCH_SUCCESS: 'RELATION_SEARCH_SUCCESS',
    RELATION_SEARCH_FAILURE: 'RELATION_SEARCH_FAILURE',

    ADD_RETAILER_SOLDTO_REQUEST: 'ADD_RETAILER_SOLDTO_REQUEST',
    ADD_RETAILER_SOLDTO_SUCCESS: 'ADD_RETAILER_SOLDTO_SUCCESS',
    ADD_RETAILER_SOLDTO_FAILURE: 'ADD_RETAILER_SOLDTO_FAILURE',
    ADD_RETAILER_SOLDTO_CLEAR_TOAST: 'ADD_RETAILER_SOLDTO_CLEAR_TOAST',

    RETAILER_LOYALTY_LIST_REQUEST: 'RETAILER_LOYALTY_LIST_REQUEST',
    RETAILER_LOYALTY_LIST_SUCCESS: 'RETAILER_LOYALTY_LIST_SUCCESS',
    RETAILER_LOYALTY_LIST_FAILURE: 'RETAILER_LOYALTY_LIST_FAILURE',

    UPDATE_RETAILER_LOYALTY_POINT_REQUEST: 'UPDATE_RETAILER_LOYALTY_POINT_REQUEST',
    UPDATE_RETAILER_LOYALTY_POINT_SUCCESS: 'UPDATE_RETAILER_LOYALTY_POINT_SUCCESS',
    UPDATE_RETAILER_LOYALTY_POINT_FAILURE: 'UPDATE_RETAILER_LOYALTY_POINT_FAILURE',
    UPDATE_RETAILER_LOYALTY_POINT_CLEAR_TOAST: 'UPDATE_RETAILER_LOYALTY_POINT_CLEAR_TOAST',

    RETAILER_LOYALTY_SEARCH_REQUEST: 'RETAILER_LOYALTY_SEARCH_REQUEST',
    RETAILER_LOYALTY_SEARCH_SUCCESS: 'RETAILER_LOYALTY_SEARCH_SUCCESS',
    RETAILER_LOYALTY_SEARCH_FAILURE: 'RETAILER_LOYALTY_SEARCH_FAILURE',

    DELETE_RETAILER_LOYALTY_REQUEST: 'DELETE_RETAILER_LOYALTY_REQUEST',
    DELETE_RETAILER_LOYALTY_SUCCESS: 'DELETE_RETAILER_LOYALTY_SUCCESS',
    DELETE_RETAILER_LOYALTY_FAILURE: 'DELETE_RETAILER_LOYALTY_FAILURE',
    DELETE_RETAILER_LOYALTY_CLEAR_TOAST: 'DELETE_RETAILER_LOYALTY_CLEAR_TOAST',

    ADD_SOLD_TO_SUBDEALER_REQUEST: 'ADD_SOLD_TO_SUBDEALER_REQUEST',
    ADD_SOLD_TO_SUBDEALER_SUCCESS: 'ADD_SOLD_TO_SUBDEALER_SUCCESS',
    ADD_SOLD_TO_SUBDEALER_FAILURE: 'ADD_SOLD_TO_SUBDEALER_FAILURE',
    ADD_SOLD_TO_SUBDEALER_CLEAR_TOAST: 'ADD_SOLD_TO_SUBDEALER_CLEAR_TOAST',

    RETAILER_DOWNLOAD_CONTACT_VNLK_REQUEST: 'RETAILER_DOWNLOAD_CONTACT_VNLK_REQUEST',
    RETAILER_DOWNLOAD_CONTACT_VNLK_SUCCESS: 'RETAILER_DOWNLOAD_CONTACT_VNLK_SUCCESS',
    RETAILER_DOWNLOAD_CONTACT_VNLK_FAILURE: 'RETAILER_DOWNLOAD_CONTACT_VNLK_FAILURE',

    AUTO_SUB_DEALER_LIST_REQUEST: 'AUTO_SUB_DEALER_LIST_REQUEST',
    AUTO_SUB_DEALER_LIST_SUCCESS: 'AUTO_SUB_DEALER_LIST_SUCCESS',
    AUTO_SUB_DEALER_LIST_FAILURE: 'AUTO_SUB_DEALER_LIST_FAILURE',

    DEALER_ACTIVITY_POINT_REQUEST: 'GET_DEALER_ACTIVITY_POINT_REQUEST',
    DEALER_ACTIVITY_POINT_SUCCESS: 'GET_DEALER_ACTIVITY_POINT_SUCCESS',
    DEALER_ACTIVITY_POINT_FAILURE: 'GET_DEALER_ACTIVITY_POINT_FAILURE',

    VOLUME_ALLOCATION_LOYALTY_REQUEST: 'GET_VOLUME_ALLOCATION_LOYALTY_REQUEST',
    VOLUME_ALLOCATION_LOYALTY_SUCCESS: 'GET_VOLUME_ALLOCATION_LOYALTY_SUCCESS',
    VOLUME_ALLOCATION_LOYALTY_FAILURE: 'GET_VOLUME_ALLOCATION_LOYALTY_FAILURE',


    SUB_DEALER_ACTIVITY_POINT_REQUEST: 'GET_SUB_DEALER_ACTIVITY_POINT_REQUEST',
    SUB_DEALER_ACTIVITY_POINT_SUCCESS: 'GET_SUB_DEALER_ACTIVITY_POINT_SUCCESS',
    SUB_DEALER_ACTIVITY_POINT_FAILURE: 'GET_SUB_DEALER_ACTIVITY_POINT_FAILURE',

    ADJUST_LOYALTY_REPORT_REQUEST: 'GET_ADJUST_LOYALTY_REPORT_REQUEST',
    ADJUST_LOYALTY_REPORT_SUCCESS: 'GET_ADJUST_LOYALTY_REPORT_SUCCESS',
    ADJUST_LOYALTY_REPORT_FAILURE: 'GET_ADJUST_LOYALTY_REPORT_FAILURE',

    ADJUST_REPORT_LIST_REQUEST: 'ADJUST_REPORT_LIST_REQUEST',
    ADJUST_REPORT_LIST_SUCCESS: 'ADJUST_REPORT_LIST_SUCCESS',
    ADJUST_REPORT_LIST_FAILURE: 'ADJUST_REPORT_LIST_FAILURE',

    VOLUME_ALLOCATION_LOYALTY_REPORT_REQUEST: 'VOLUME_ALLOCATION_LOYALTY_REPORT_REQUEST',
    VOLUME_ALLOCATION_LOYALTY_REPORT_SUCCESS: 'VOLUME_ALLOCATION_LOYALTY_REPORT_SUCCESS',
    VOLUME_ALLOCATION_LOYALTY_REPORT_FAILURE: 'VOLUME_ALLOCATION_LOYALTY_REPORT_FAILURE',

    
    DEALER_ACTIVITY_LOYALTY_REPORT_REQUEST: 'DEALER_ACTIVITY_LOYALTY_REPORT_REQUEST',
    DEALER_ACTIVITY_LOYALTY_REPORT_SUCCESS: 'DEALER_ACTIVITY_LOYALTY_REPORT_SUCCESS',
    DEALER_ACTIVITY_LOYALTY_REPORT_FAILURE: 'DEALER_ACTIVITY_LOYALTY_REPORT_FAILURE',

    SUB_DEALER_LOYALTY_REPORT_REQUEST: 'SUB_DEALER_LOYALTY_REPORT_REQUEST',
    SUB_DEALER_LOYALTY_REPORT_SUCCESS: 'SUB_DEALER_LOYALTY_REPORT_SUCCESS',
    SUB_DEALER_LOYALTY_REPORT_FAILURE: 'SUB_DEALER_LOYALTY_REPORT_FAILURE',

    BILLING_YEAR_LIST_REQUEST: 'BILLING_YEAR_LIST_REQUEST',
    BILLING_YEAR_LIST_SUCCESS: 'BILLING_YEAR_LIST_SUCCESS',
    BILLING_YEAR_LIST_FAILURE: 'BILLING_YEAR_LIST_FAILURE',


    DOWNLOAD_DEALER_ACTIVITY_REQUEST: 'DOWNLOAD_DEALER_ACTIVITY_REQUEST',
    DOWNLOAD_DEALER_ACTIVITY_SUCCESS: 'DOWNLOAD_DEALER_ACTIVITY_SUCCESS',
    DOWNLOAD_DEALER_ACTIVITY_FAILURE: 'DOWNLOAD_DEALER_ACTIVITY_FAILURE',

    DOWNLOAD_VOLUME_ALLOCATION_REQUEST: 'DOWNLOAD_VOLUME_ALLOCATION_REQUEST',
    DOWNLOAD_VOLUME_ALLOCATION_SUCCESS: 'DOWNLOAD_VOLUME_ALLOCATION_SUCCESS',
    DOWNLOAD_VOLUME_ALLOCATION_FAILURE: 'DOWNLOAD_VOLUME_ALLOCATION_FAILURE',

    DOWNLOAD_SUB_DEALER_ACTIVITY_REQUEST: 'DOWNLOAD_SUB_DEALER_ACTIVITY_REQUEST',
    DOWNLOAD_SUB_DEALER_ACTIVITY_SUCCESS: 'DOWNLOAD_SUB_DEALER_ACTIVITY_SUCCESS',
    DOWNLOAD_SUB_DEALER_ACTIVITY_FAILURE: 'DOWNLOAD_SUB_DEALER_ACTIVITY_FAILURE',

    DOWNLOAD_ADJUST_LOYALTY_REQUEST: 'DOWNLOAD_ADJUST_LOYALTY_REQUEST',
    DOWNLOAD_ADJUST_LOYALTY_SUCCESS: 'DOWNLOAD_ADJUST_LOYALTY_SUCCESS',
    DOWNLOAD_ADJUST_LOYALTY_FAILURE: 'DOWNLOAD_ADJUST_LOYALTY_FAILURE',

    ADD_CLASS_WITH_STYLE_REQUEST: 'ADD_CLASS_WITH_STYLE_REQUEST',
    ADD_CLASS_WITH_STYLE_SUCCESS: 'ADD_CLASS_WITH_STYLE_SUCCESS',
    ADD_CLASS_WITH_STYLE_FAILURE: 'ADD_CLASS_WITH_STYLE_FAILURE',

    FONT_SIZE_CHANGER_REQUEST: 'FONT_SIZE_CHANGER_REQUEST',
    FONT_SIZE_CHANGER_SUCCESS: 'FONT_SIZE_CHANGER_SUCCESS',
    FONT_SIZE_CHANGER_FAILURE: 'FONT_SIZE_CHANGER_FAILURE',

    ADJUST_LOYALTY_DELETE_ADMIN_REQUEST: 'ADJUST_LOYALTY_DELETE_ADMIN_REQUEST',
    ADJUST_LOYALTY_DELETE_ADMIN_SUCCESS: 'ADJUST_LOYALTY_DELETE_ADMIN_SUCCESS',
    ADJUST_LOYALTY_DELETE_ADMIN_FAILURE: 'ADJUST_LOYALTY_DELETE_ADMIN_FAILURE',
    ADJUST_LOYALTY_DELETE_ADMIN_CLEAR_TOAST: 'ADJUST_LOYALTY_DELETE_ADMIN_CLEAR_TOAST',

    MULTI_CHECK_BOX_REQUEST: 'MULTI_CHECK_BOX_REQUEST',
    MULTI_CHECK_BOX_SUCCESS: 'MULTI_CHECK_BOX_SUCCESS',
    MULTI_CHECK_BOX_FAILURE: 'MULTI_CHECK_BOX_FAILURE',

    DOWNLOAD_ADJUST_LOYALTY_ADMIN_REQUEST: 'DOWNLOAD_ADJUST_LOYALTY_ADMIN_REQUEST',
    DOWNLOAD_ADJUST_LOYALTY_ADMIN_SUCCESS: 'DOWNLOAD_ADJUST_LOYALTY_ADMIN_SUCCESS',
    DOWNLOAD_ADJUST_LOYALTY_ADMIN_FAILURE: 'DOWNLOAD_ADJUST_LOYALTY_ADMIN_FAILURE',


    ADJUST_LOYALTY_ADMIN_FILTER_REQUEST: 'GET_ADJUST_LOYALTY_ADMIN_FILTER_REQUEST',
    ADJUST_LOYALTY_ADMIN_FILTER_SUCCESS: 'GET_ADJUST_LOYALTY_ADMIN_FILTER_SUCCESS',
    ADJUST_LOYALTY_ADMIN_FILTER_FAILURE: 'GET_ADJUST_LOYALTY_ADMIN_FILTER_FAILURE',
     
    ALL_EXPIRED_EXPIRE_RULES_REQUEST: 'ALL_EXPIRED_EXPIRE_RULES_REQUEST',
    ALL_EXPIRED_EXPIRE_RULES_SUCCESS: 'ALL_EXPIRED_EXPIRE_RULES_SUCCESS',
    ALL_EXPIRED_EXPIRE_RULES_FAILURE: 'ALL_EXPIRED_EXPIRE_RULES_FAILURE',

    RETAILER_PROVINCE_REQUEST: 'GET_RETAILER_PROVINCE_REQUEST',
    RETAILER_PROVINCE_SUCCESS: 'GET_RETAILER_PROVINCE_SUCCESS',
    RETAILER_PROVINCE_FAILURE: 'GET_RETAILER_PROVINCE_FAILURE',

    RETAILER_DISTRICT_REQUEST: 'GET_RETAILER_DISTRICT_REQUEST',
    RETAILER_DISTRICT_SUCCESS: 'GET_RETAILER_DISTRICT_SUCCESS',
    RETAILER_DISTRICT_FAILURE: 'GET_RETAILER_DISTRICT_FAILURE',

    RETAILER_SUB_DISTRICT_REQUEST: 'GET_RETAILER_SUB_DISTRICT_REQUEST',
    RETAILER_SUB_DISTRICT_SUCCESS: 'GET_RETAILER_SUB_DISTRICT_SUCCESS',
    RETAILER_SUB_DISTRICT_FAILURE: 'GET_RETAILER_SUB_DISTRICT_FAILURE',

    SALES_SOLDTO_AREALIST_REQUEST: 'GET_SALES_SOLDTO_AREALIST_REQUEST',
    SALES_SOLDTO_AREALIST_SUCCESS: 'GET_SALES_SOLDTO_AREALIST_SUCCESS',
    SALES_SOLDTO_AREALIST_FAILURE: 'GET_SALES_SOLDTO_AREALIST_FAILURE',



};
